import React from 'react';

import { v4 as uuidv4 } from 'uuid';

import formatNumbers from 'util/formatNumbers';
import ReactDOM from 'react-dom';
import sharedUtil from '../../../sharedUtil';
import {
  base64ToHex,
  hexToBase64,
  customFormatter,
  deleteImagesFromS3,
  displayCustomDialog,
  formatImageForBucket,
  generateMongoObjectID,
} from 'util/Utils';
import { IframeInBoundListener } from 'dashboard/inbound/iframe-inbound';
import { UPDATE_CUSTOM_USER_DATA } from 'actions/actionTypes';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import FaMinusCircle from 'react-icons/lib/fa/minus-circle';
import Toggle from 'react-bootstrap-toggle';
import ImageList from 'shared/ImageList';
import { isPartner, brandsFromPartner } from 'dashboard/services/partners/Partner';
import {
  ListingSelectionScreen,
  RMAProductsSelectionScreen,
  ParcelPalletScanningScreen,
  FeesScreen,
  PrintingScreen,
  LocationScanningScreen,
  ScanningScreen,
} from 'dashboard/processing/screens';
import ConditionScaleComponent from 'dashboard/processing/ConditionScaleComponent';
import Colors from 'util/Colors';

import { getModelVariationsForUPCCode, searchUPCCodesDebounce } from 'dashboard/processing/3PLSharedMethods';

import {
  barcodeScanningTextCallback,
  displayCalculatedBoxSize,
  displayGBGProductsInGrid,
  displayPrevNextButtons,
  displayProductBoxSize,
  displayProductImages,
  displayProductSKUs,
  displayQualityCheckItems,
  getAmazonProductData,
  getSelectedCategories,
  getSimilarProducts,
  locationInWarehouseTextCallback,
  prepareDataForDonation,
  prepareDataForScreen,
  prepareModelsOptions,
  prepareModelVariationsToSave,
  prepareProductAgeRange,
  prepareProductCategories,
  processScannedData,
  processSimilarProducts,
  processVariationsForPallets,
  renderFeeList,
  renderModelVariationOptions,
  SCREENS,
  searchGBGProducts,
  searchGBGProductsDebounce,
  getNextScreenName,
  searchProductsWithAPI,
  sentenceCase,
  trackingNumberScannedCallback,
  updatePalletProduct,
  allFeesList,
} from 'dashboard/processing/PostingSharedMethods';
import QualityCheckList from 'dashboard/processing/components/QualityCheckList';
import {
  getSellerType,
  qualityCheckAnswerHandler,
  selectProductListing,
} from 'dashboard/processing/ProcessingScreensMethods';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import classNames from 'classnames';

import { Button, Checkbox, Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';

import FaClose from 'react-icons/lib/fa/close';
import IORefresh from 'react-icons/lib/io/refresh';

import PaginationBox from 'shared/PaginationBox';

import config from '../../../config';
import _ from 'lodash';
import ViewImageComponent from 'dashboard/processing/components/ViewImageComponent';

const validateBarcode = require('barcode-validator');

var mime = require('mime-types');
let sortByList = [
  {
    value: 'ServiceStartTime:-1',
    label: 'Service Date New',
    filterLabel: 'Date New',
  },
  {
    value: 'ServiceStartTime:1',
    label: 'Service Date Old',
    filterLabel: 'Date Old',
  },
];
var GBGProductsFieldsToKeep = [
  'selectedGBGProduct',
  'GBGProductNotFound',
  'PersonalNote',
  'ProductAgeRange',
  'GBGProductsModel',
  'GBGProductsBrand',
  'GBGProductImage',
  'ProductCategories',
  'GBGID',
  'ServiceItemMarket',
  'currentServiceRecord',
  'RMAProductsData',
  'ProductName',
  'ProductCategories',
  'listingsFetched',
  'listingsData',
  'upcCodeToSave',
];
var instructionsToTextMap = {
  RECALLED: {
    Text: 'Recalled Item- Donate',
    AdditionalText: '',
  },
  'TROUBLESHOOTING ROOM': {
    Text: 'Check into troubleshooting room',
    AdditionalText:
      'Based on these unchecked QA questions, we suggest you check this item into the Troubleshooting Room',
  },
  DONATE: {
    Text: 'Donate',
    AdditionalText: 'Based on these unchecked QA questions, we suggest you donate this item',
  },
};
function generateBarcodesInPrintingScreen(params) {
  const self = this;
  self.generateBarcodes
    .call(self, params)
    .then((barcodeImages) => {
      console.log('barcodeImages', barcodeImages);
      const { selectedPrinter = {} } = self.state.screensData;
      self.setScreensData({ barcodeImages: barcodeImages });

      if (selectedPrinter.name) {
        self.printBarcodes
          .call(self, {
            convertImage4: true,
            barcodeImages: barcodeImages,
          })
          .then((res) => {
            self.setScreensData({ barcodePrinted: true });
            self.setState({ pending: false });
          })
          .catch((err) => {
            self.setState({ pending: false });
          });
      } else {
        self.setState({ pending: false });
        console.log('printer not selected 1');
      }
    })
    .catch((err) => {
      console.log('err', err);
      self.setState({ pending: false });
    });
}

export function displayScreenContent() {
  var self = this;

  console.log('====== Screens =====')
  console.log(self.state.screensData)
  console.log(this.state.currentScreen)

  switch (this.state.currentScreen) {
    case SCREENS.barcode_scanning_screen.key:
      let displayScreen = true;

      if (
        (this.props.appData.FeatureFlags.initialData ||
          (this.props.appData.FeatureFlags.UseGBGIDIn3PL && this.state.currentFlow == '3PLProcessingFlow')) &&
        this.props.allSellerPickupsListReducer.data.length == 0
      ) {
        displayScreen = false;
      }

      return (
        <div className={'screen-box barcode_scanning_screen'}>
          {displayPrevNextButtons.call(this, {})}
          {displayScreen ? (
            <ScanningScreen
              {...this.props}
              timerComponent={this.timerRef}
              resetScreensData={this.resetScreensData}
              ProductsSettingsData={this.ProductsSettingsData}
              setScreensData={self.setScreensData}
              {..._.pick(this.state, ['screensData', 'pending', 'currentFlow'])}
              processBarcodeHandler={() => {
                const BarcodeNumber = self.state.screensData.BarcodeNumber.trim();
                self.setScreensData({ BarcodeNumber });
                processScannedData
                  .call(self, BarcodeNumber, {
                    ScanAction: 'ScanBarcodeNumber',
                  })
                  .then(() => {
                    self.setScreensData({ BarcodeNumberTyped: false }, () => {
                      self.goToNextScreen(SCREENS.conditions_screen.key);
                    });
                  })
                  .catch((err) => {
                    self.setState({ pending: false });
                  });
              }}
              processGBGIDCallback={(responseData, foundSellerAndPickup) => {
                const { RMAProductsData = {} } = responseData;
                let additionalData = {
                  RMAProductsData,
                  GBGID: responseData.gbg_id,
                };
                self.setScreensData({ BarcodeNumber: self.state.screensData.BarcodeNumber.trim() });

                if (responseData.market_name) {
                  additionalData.ServiceItemMarket = responseData.market_name;
                }

                if (self.props.appData.FeatureFlags.UseGBGIDIn3PL && self.state.currentFlow == '3PLProcessingFlow') {
                  if (!responseData.tracking_number) {
                    return this.props.displayMessage({
                      messageType: 'warning',
                      messageCode: `Tracking number is not available for GBG ID ${responseData.gbg_id}`,
                    });
                  }

                  let screenKey = SCREENS.conditions_screen.key;
                  if (RMAProductsData.RMAProducts && RMAProductsData.RMAProducts.length > 0) {
                    screenKey = SCREENS.rma_products_selection_screen.key;
                  }
                  return self.goToNextScreen(screenKey, {
                    screenDataToSet: {
                      ...additionalData,
                      TrackingNumbers: [
                        {
                          TrackingNumber: responseData.tracking_number,
                          GBGID: responseData.gbg_id,
                        },
                      ],
                      currentServiceRecord: foundSellerAndPickup,
                      SellerID: foundSellerAndPickup.SellerID._id,
                      PickupID: foundSellerAndPickup._id,
                    },
                  });
                }
                self.goToPrelistingFlow({
                  match: [
                    null,
                    foundSellerAndPickup.SellerID.SellerNumber,
                    foundSellerAndPickup.SellerPickupNumber,
                    'generate_next_number',
                  ],
                  type: 'new_prelisting',
                  foundSellerAndPickup,
                  additionalData,
                });
              }}
              findNextAvailableCallback={() =>
                self.setScreensData({ currentAction: 'FindNextAvailableSKU' }, () =>
                  self.goToNextScreen(SCREENS.service_selection_screen.key, {
                    nextScreenCallback: () => {
                      self.searchServices({});
                    },
                  })
                )
              }
              barcodeScanningTextCallback={() => barcodeScanningTextCallback.call(self)}
              updateParentComponentState={(dataToUpdate) => {
                self.setState(dataToUpdate);
              }}
              setBarCodeNumberInput={(barcodeNumberInput) => {
                self.barcodeNumberInput = barcodeNumberInput;
              }}
            ></ScanningScreen>
          ) : (
            <div className="pending-box"></div>
          )}
        </div>
      );
    case SCREENS.inbound_rebound_screen.key:
      const user = this.props.userReducer.user
      const user_id = base64ToHex(user._id,{convertToHEXUUID:true})
      const user_first_name = user.firstName
      const user_last_name = user.lastName
      const user_email = user.email

      const handleIframeCallBack = (data) => {
        //The callback is trigger also for this function when the process is finished.
        //So we need to validate if the data has finished inside of it to avoid to trigger the callback twice
        if(!data.finished){
          console.log('======================== HANDLER CALLBACK FROM IPA INBOUND REBOUND START ==========================================')
          console.log('Data sent')
          console.log(data)
  
          //Any mapping or extra information here
          self.setState({
            screensData: {
              ...self.state.screensData,
              ...data,
            },
          });
          const dataToSave = {
            ...self.state.screensData,
            ...data
          }
          console.log('============= SENDING DATA TO SAVE =============')
          console.log(dataToSave)
          return self.goToQualityCheckScreen(dataToSave)
          // return self.goToNextScreen(SCREENS.quality_checks_screen.key);
        } else if (data.finished) {
          console.log('=========== HANDLER CALLBACK FROM IPA ============')
          console.log(data)
          self.setScreensData({
              requestFlowId: uuidv4(),
              showModal: false,
              currentFlow: "3PLProcessingFlow",
              currentScreen: SCREENS.inbound_rebound_screen.key,
              screensData: SCREENS.inbound_rebound_screen.key,
              screensStack: [SCREENS.inbound_rebound_screen.key],
              currentRecord: {},
              currentTimeTracked: ''
          })
          self.resetScreensData()
          this.state.currentScreen = SCREENS.inbound_rebound_screen.key
          console.log('=========== HANDLER CALLBACK FROM IPA END ============', data)

          window.location.reload()
        }
      };

      return <IframeInBoundListener IPAenvironmentURL={`${config.getEnvironment().IPABaseURL}/inbound/?user_id=${user_id}&firstName=${user_first_name}&lastName=${user_last_name}&email=${user_email}`} onDataReceived={handleIframeCallBack} />

    case SCREENS.inbound_rebound_add_inventory.key:

      const handleAddInventoryCallBack = (data) => {
        if (data.finished) {
          console.log('=========== HANDLER CALLBACK FROM IPA ============')
          console.log(data)
          self.setScreensData({
              requestFlowId: uuidv4(),
              showModal: false,
              currentFlow: "3PLProcessingFlow",
              currentScreen: SCREENS.inbound_rebound_screen.key,
              screensData: SCREENS.inbound_rebound_screen.key,
              screensStack: [SCREENS.inbound_rebound_screen.key],
              currentRecord: {},
              currentTimeTracked: ''
          })
          self.resetScreensData()
          this.state.currentScreen = SCREENS.inbound_rebound_screen.key
          console.log('=========== HANDLER CALLBACK FROM IPA END ============', data)

          window.location.reload()
        }
      }

      //This is necessary because sometimes it breaks when parsers the data
      let inputData = {...this.state.screensData, roles: this.props.userReducer?.user?.Roles}
      inputData = JSON.parse(JSON.stringify(inputData, null, 4))
      inputData.servicesListData = undefined

      return (
        <IframeInBoundListener
          inputData={inputData}
          IPAenvironmentURL={config.getEnvironment().IPABaseURL + '/inbound/add_inventory'}
          onDataReceived={handleAddInventoryCallBack}
        />
      );
    case SCREENS.service_selection_screen.key:
      return (
        <div className={'screen-box service_selection_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <div className="screen-content ">
            <Row className="bot20">
              <Col xs={12} className="screen_title text-center">
                Select a seller
              </Col>
              <Col md={3} xs={6} className="top10 ">
                <FormControl
                  type="text"
                  value={_.get(this.state.screensData, 'servicesListSearchText', '')}
                  data-testid="service-search-input"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      self.searchServicesDebounce({});
                    }
                  }}
                  onChange={(event) => {
                    self.setScreensData({ servicesListSearchText: event.target.value }, () => {
                      self.searchServicesDebounce({});
                    });
                  }}
                  placeholder="Search"
                />
              </Col>
              <Col md={3} xs={6} className=" top10" data-testid="service-search-select-box">
                <Select
                  tabIndex="0"
                  placeholder="Seller"
                  clearable={true}
                  options={
                    this.state.currentFlow == '3PLProcessingFlow'
                      ? _.filter(this.allSellersOptionsList, (item) => {
                          return _.get(item, 'InventoryOwnership') == 'PartnerConsigned';
                        })
                      : this.allSellersOptionsList
                  }
                  onChange={(option) => {
                    var self = this;
                    let stateDataToUpdate = { servicesListSellerID: option ? option.value : null };
                    if (self.state.currentFlow == '3PLProcessingFlow') {
                      let dataToUpdate = {
                        processing3PLFlowSelectedSellerID: option ? option.value : null,
                      };

                      if (!option) {
                        stateDataToUpdate.servicesListSearchText = '';
                        dataToUpdate.processing3PLFlowServiceSearchText = '';
                      }

                      self.props.dispatchAction(dataToUpdate, UPDATE_CUSTOM_USER_DATA);
                    }

                    self.setScreensData(stateDataToUpdate, () => {
                      self.searchServices({});
                    });
                  }}
                  value={_.get(this.state.screensData, 'servicesListSellerID')}
                />
              </Col>
              <Col md={3} xs={6} className="top10" data-testid="market-select-box">
                <Select
                  tabIndex="0"
                  multi
                  clearable={false}
                  placeholder="Location"
                  options={_.map(config.warehouseData, (item) => {
                    return { value: item.MarketName, label: item.MarketName };
                  })}
                  onChange={(options) => {
                    var self = this;

                    if (self.state.currentFlow == '3PLProcessingFlow') {
                      self.props.dispatchAction(
                        {
                          processing3PLFlowSelectedLocations: options,
                        },
                        UPDATE_CUSTOM_USER_DATA
                      );
                    }
                    self.setScreensData({ servicesListMarkets: options }, () => {
                      self.searchServices({});
                    });
                  }}
                  value={_.get(this.state.screensData, 'servicesListMarkets', [])}
                />
              </Col>
              <Col md={3} xs={6} className=" top10  " data-testid="sort-by-select-box">
                <Select
                  tabIndex="0"
                  placeholder="Sort By"
                  clearable={true}
                  options={sortByList}
                  onChange={(option) => {
                    var self = this;
                    self.setScreensData({ servicesListSortBy: option ? option.value : null }, () => {
                      self.refs.pagination.resetPagination();
                      self.searchServices({});
                    });
                  }}
                  value={_.get(this.state.screensData, 'servicesListSortBy')}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6} xs={12} className=" text-center align-center">
                {this.state.screensData.servicesListFetched && (
                  <div>
                    {this.state.screensData.servicesListData.length == 0 ? (
                      <div className="messageBox font-size-19">{'No matching services found'}</div>
                    ) : (
                      <div className="">
                        <BootstrapTable
                          data={_.get(this.state.screensData, 'servicesListData', [])}
                          ref="table"
                          hover={true}
                          bordered={false}
                          style={{ maxHeight: 500 }}
                          //    condensed={true}
                          //  striped={true}
                          // options={{
                          //     onRowClick: function(row) {
                          //         console.log('on row click', row  );
                          // }}  }
                          selectRow2={{
                            mode: 'checkbox',
                            bgColor: 'pink', // you should give a bgcolor, otherwise, you can't regonize which row has been selected
                            hideSelectColumn: true,
                            clickToSelect: true, // you should enable clickToSelect, otherwise, you can't select column.
                            selected: _.get(self.state.screensData, 'selectedRows', []),
                            onSelect: (row) => {
                              console.log('on row click', row);
                              self.searchServices({}, (data) => {
                                self.setScreensData({ selectedRows: [row._id] });
                              });
                            },
                          }}
                        >
                          <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={true} hiddenOnInsert>
                            Id
                          </TableHeaderColumn>

                          <TableHeaderColumn
                            width="60px"
                            editable={false}
                            dataFormat={customFormatter}
                            columnClassName={'service-list-column'}
                            dataField="ProductItemQuantity"
                            formatExtraData={{
                              path: ['getObject'],
                              format: (item) => {
                                var TimeWindow = _.map(_.split(item.TimeWindow, '_'), function (time) {
                                  return time;
                                });

                                if (_.get(item, 'SellerID.PartnerData.Name')) {
                                  var backgroundColor = _.get(item, 'MarketName') == 'Denver' ? '#d4fbfc' : '#f9f9d1';
                                } else {
                                  var backgroundColor = _.get(item, 'MarketName') == 'Denver' ? '#dbe2ff' : '#fcf2f5';
                                }

                                var ServiceTimeWindow = '';
                                if (item.TimeWindow) {
                                  var startHourAndMinutes = _.split(TimeWindow[0], '.');
                                  var endHourAndMinutes = _.split(TimeWindow[1], '.');

                                  if (startHourAndMinutes[0] < 12 && endHourAndMinutes[0] >= 12) {
                                    ServiceTimeWindow =
                                      startHourAndMinutes[0] +
                                      (_.isUndefined(startHourAndMinutes[1]) ? '' : ':' + startHourAndMinutes[1]) +
                                      'am-' +
                                      config.servicesHoursMap[endHourAndMinutes[0]] +
                                      (_.isUndefined(endHourAndMinutes[1]) ? '' : ':' + endHourAndMinutes[1]) +
                                      'pm';
                                  } else {
                                    ServiceTimeWindow =
                                      config.servicesHoursMap[startHourAndMinutes[0]] +
                                      (_.isUndefined(startHourAndMinutes[1]) ? '' : ':' + startHourAndMinutes[1]) +
                                      '-' +
                                      config.servicesHoursMap[endHourAndMinutes[0]] +
                                      (_.isUndefined(endHourAndMinutes[1]) ? '' : ':' + endHourAndMinutes[1]) +
                                      (endHourAndMinutes[0] < 12 ? 'am' : 'pm');
                                  }
                                } else {
                                  /* services related to Pallets */
                                  ServiceTimeWindow =
                                    moment(_.get(item, 'ServiceStartTime')).format('MM/DD') +
                                    '-' +
                                    moment(_.get(item, 'ServiceEndTime')).format('MM/DD');
                                }

                                return (
                                  <Row
                                    data-testid="service-item-row-box"
                                    onClick={() => {
                                      if (self.state.currentFlow == '3PLProcessingFlow') {
                                        self.props.dispatchAction(
                                          {
                                            processing3PLFlowSelectedSellerID: item.SellerID ? item.SellerID._id : null,
                                            processing3PLFlowServiceSearchText: item.PickupNumberString,
                                          },
                                          UPDATE_CUSTOM_USER_DATA
                                        );
                                      }
                                      if (_.get(this.state.screensData, 'currentAction') == 'FindNextAvailableSKU') {
                                        self.setScreensData(
                                          {
                                            currentServiceRecord: item,
                                            servicesListSellerID: item.SellerID._id,
                                            servicesListSearchText: item.PickupNumberString,
                                          },
                                          () => {
                                            self
                                              .getNextSKU()
                                              .then((nextProductNumber) => {
                                                var BarcodeNumber =
                                                  _.get(item, ['SellerID', 'SellerNumber'], '') +
                                                  '.' +
                                                  _.get(item, ['SellerPickupNumber'], '') +
                                                  '.' +
                                                  nextProductNumber;
                                                self.setScreensData(
                                                  {
                                                    BarcodeNumber: BarcodeNumber,
                                                    currentAction: '',
                                                  },
                                                  () => {
                                                    self.goToNextScreen(SCREENS.barcode_scanning_screen.key, {
                                                      screensToRemove: [SCREENS.service_selection_screen.key],
                                                    });
                                                  }
                                                );
                                              })
                                              .catch((err) => {
                                                console.log('err', err);
                                              });
                                          }
                                        );
                                      } else {
                                        self.setScreensData(
                                          {
                                            currentServiceRecord: item,
                                            servicesListSellerID: item.SellerID._id,
                                            servicesListSearchText: item.PickupNumberString,
                                            listingsSearchText:
                                              _.get(item, 'SellerID.SellerNumber') +
                                              '.' +
                                              _.get(item, 'SellerPickupNumber') +
                                              '.',
                                          },
                                          () => {
                                            self.goToNextScreen(SCREENS.parcel_pallet_screen.key);
                                          }
                                        );
                                      }
                                    }}
                                    className="cell-content pleft10 ptop15 pbot10 pright10"
                                    style={{
                                      backgroundColor: backgroundColor,
                                    }}
                                  >
                                    <Col xs={9}>
                                      {_.get(item, 'SellerID.PartnerData.Name') ? (
                                        <div className="  text-bold orange text-left  ">
                                          <div className=" orange">
                                            {_.get(item, 'SellerID.PartnerData.Name') +
                                              '  ' +
                                              _.get(item, 'SellerPickupNumber', '')}
                                          </div>
                                          <div className="text-left">
                                            <span className="green">
                                              {' '}
                                              {_.get(item, 'SellerID.SellerNumber') +
                                                '.' +
                                                _.get(item, 'SellerPickupNumber', '')}
                                            </span>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className=" text-bold   text-left">
                                          <div className=" orange">
                                            {_.get(item, 'SellerID.DisplayName', '') +
                                              '.' +
                                              _.get(item, 'SellerPickupNumber', '') +
                                              (_.get(item, 'PalletID') ? '   Pallet' : '')}
                                          </div>
                                          <div>{_.get(item, 'UserID.email', '')}</div>
                                        </div>
                                      )}

                                      {!_.get(item, 'SellerID.PartnerData.Name') && (
                                        <div className="  text-bold  text-left ">
                                          <div className="  text-bold  text-left">{_.get(item, 'Type', '')}</div>

                                          <div className="  text-bold  text-left">
                                            {moment(_.get(item, 'ServiceStartTime')).format('MM/DD/YYYY')}
                                          </div>

                                          <div className="  text-bold  text-left">{ServiceTimeWindow}</div>
                                        </div>
                                      )}
                                    </Col>

                                    <Col xs={3}>
                                      <Button
                                        data-testid="service-item-select-button"
                                        className="btn btn-lg btn-primary custom-btn "
                                        onClick={() => {
                                          self.setScreensData({ currentServiceRecord: item }, () => {
                                            self.goToNextScreen(SCREENS.parcel_pallet_screen.key);
                                          });
                                        }}
                                      >
                                        Select
                                      </Button>
                                    </Col>
                                  </Row>
                                );
                              },
                            }}
                            dataAlign="center"
                          >
                            Services
                          </TableHeaderColumn>
                        </BootstrapTable>

                        <PaginationBox
                          ref={'pagination'}
                          customTotalBoxClass={'float-none'}
                          currentPage={_.get(this.state.screensData, 'servicesListPage', 0)}
                          perPage={50}
                          total={_.get(this.state.screensData, 'servicesListTotal', 1)}
                          search={(params) => {
                            self.searchServices(params);
                          }}
                        ></PaginationBox>
                      </div>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      );
    case SCREENS.parcel_pallet_screen.key:
      return (
        <div className={'screen-box parcel_pallet_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" text-center align-center">
              <div className="screen_title">Is this item from a pallet or parcel?</div>
              <div className="top30 ">
                <Button
                  data-testid="pallet-button"
                  className="btn btn-lg btn-primary set-width  "
                  onClick={() => {
                    self.setScreensData({ TrackingServiceType: '', PalletType: 'Pallet' }, () => {
                      self.goToNextScreen(SCREENS.parcel_pallet_scanning_screen.key, {
                        nextScreenCallback: () => {
                          ReactDOM.findDOMNode(self.trackingNumberInput).focus();
                        },
                      });
                    });
                  }}
                >
                  Pallet
                </Button>
              </div>
              <div className="top30 ">
                <Button
                  data-testid="parcel-button"
                  className="btn btn-lg btn-primary set-width  "
                  onClick={() => {
                    self.setScreensData({ PalletType: 'Parcel' }, () => {
                      self.goToNextScreen(SCREENS.parcel_pallet_scanning_screen.key);
                    });
                  }}
                >
                  Parcel
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
    case SCREENS.parcel_pallet_scanning_screen.key:
      return (
        <div className={'screen-box parcel_pallet_scanning_screen'}>
          {displayPrevNextButtons.call(this, {})}
          {this.props.appData.FeatureFlags.UseParcelPalletScreen ? (
            <ParcelPalletScanningScreen
              {...self.props}
              setScreensData={(dataToUpdate, callback) =>
                this.setScreensData(dataToUpdate, () => {
                  callback && callback();
                })
              }
              {..._.pick(self.state, ['screensData', 'pending'])}
              processScannedNumberCallback={(responseData) => {
                const { trackingNumberToSet } = responseData;
                processScannedData
                  .call(self, trackingNumberToSet, {
                    TrackingServiceType: self.state.screensData.TrackingServiceType,
                    ScanAction: 'ScanPartnerProduct',
                  })
                  .then(() => {
                    self.setScreensData(
                      {
                        TrackingNumberTyped: false,
                        TrackingNumber: trackingNumberToSet,
                        TrackingNumbers: [
                          {
                            TrackingNumber: trackingNumberToSet,
                          },
                        ],
                      },
                      () => {
                        self.goToNextScreen(SCREENS.conditions_screen.key);
                      }
                    );
                  })
                  .catch((err) => {
                    self.setState({ pending: false });
                  });
              }}
              updateParentComponentState={(dataToUpdate) => {
                self.setState(dataToUpdate);
              }}
              focusOnTrackingNumberInput={() => {
                ReactDOM.findDOMNode(self.trackingNumberInput).focus();
              }}
              setTrackingNumberInput={(trackingNumberInput) => {
                self.trackingNumberInput = trackingNumberInput;
              }}
            ></ParcelPalletScanningScreen>
          ) : (
            <Row className="screen-content">
              <Col xs={6} className="   text-center align-center">
                <div className="screen_title">
                  {this.state.screensData.PalletType == 'Pallet'
                    ? 'Please scan or enter the Pallet Barcode'
                    : 'Please scan or enter the tracking number on the shipping label'}
                </div>
                {this.state.screensData.PalletType == 'Parcel' && (
                  <div>
                    <div className="top30 ">
                      <Button
                        className={classNames('btn btn-lg btn-primary set-width', {
                          'custom-btn --pink': this.state.screensData.TrackingServiceType == 'FedEx',
                        })}
                        data-testid="scan-fedex-button"
                        onClick={() => {
                          self.setScreensData({ TrackingServiceType: 'FedEx' }, () => {
                            // setTimeout(()=> {
                            ReactDOM.findDOMNode(self.trackingNumberInput).focus();
                            //    },500)
                          });
                        }}
                      >
                        Scan FedEx
                      </Button>
                    </div>
                    <div className="top30 ">
                      <Button
                        className={classNames('btn btn-lg btn-primary set-width ', {
                          'custom-btn --pink': this.state.screensData.TrackingServiceType == 'USPS',
                        })}
                        style={{ backgroundColor: this.state.screensData.TrackingServiceType == 'USPS' ? '' : '' }}
                        data-testid="scan-usps-button"
                        onClick={() => {
                          self.setScreensData({ TrackingServiceType: 'USPS' }, () => {
                            ReactDOM.findDOMNode(self.trackingNumberInput).focus();
                          });
                        }}
                      >
                        {' '}
                        {'Scan USPS/UPS/RMA'}
                      </Button>
                    </div>
                  </div>
                )}
                {(this.state.screensData.TrackingServiceType || this.state.screensData.PalletType == 'Pallet') && (
                  <div className="top30 set-width" style={{ margin: '0 auto' }}>
                    <FormControl
                      value={_.get(this.state.screensData, 'TrackingNumber', '')}
                      data-testid="tracking-number-text-input"
                      componentClass="textarea"
                      ref={(trackingNumberInput) => {
                        self.trackingNumberInput = trackingNumberInput;
                      }}
                      placeholder=""
                      onKeyPress={(e) => {
                        self.setScreensData({ TrackingNumberTyped: true });
                      }}
                      onChange={(e) => {
                        var textValue = e.target.value;
                        const { TrackingNumber = '' } = this.state.screensData;
                        var dataToUpdate = { TrackingNumber: e.target.value };

                        if (TrackingNumber.length > e.target.value.length) {
                          dataToUpdate.TrackingNumberTyped = true;
                        }

                        self.setScreensData(dataToUpdate, () => {
                          setTimeout(() => {
                            const { TrackingNumberTyped = false } = self.state.screensData;

                            if (!TrackingNumberTyped) {
                              trackingNumberScannedCallback.call(self);
                            } else if (textValue == '') {
                              self.setScreensData({ TrackingNumberTyped: false });
                            }
                          }, 200);
                        });
                      }}
                      type="text"
                    />
                  </div>
                )}
                {(this.state.screensData.PalletType == 'Pallet' ||
                  (this.state.screensData.TrackingServiceType && this.state.screensData.PalletType == 'Parcel')) && (
                  <div className="top30 ">
                    <Button
                      data-testid="next-screen-button"
                      disabled={this.state.pending || _.get(this.state.screensData, 'TrackingNumber', '') == ''}
                      className="btn btn-lg btn-primary set-width "
                      onClick={() => {
                        if (this.state.pending) {
                          return;
                        }

                        var SKUmatch = this.state.screensData.TrackingNumber.match(
                          /^[\s]*(\d+)\.(\d+)\.(\d+)(\.(\d+))?[\s]*$/
                        );

                        if (SKUmatch) {
                          return this.props.displayMessage({
                            messageCode: 'Please scan the tracking number or pallet barcode, not the product SKU',
                          });
                        }

                        var trackingNumberToSet = this.state.screensData.TrackingNumber;

                        if (self.state.screensData.TrackingServiceType == 'FedEx') {
                          /* get 12 last digits from the number */
                          if (trackingNumberToSet.length > 12) {
                            trackingNumberToSet = trackingNumberToSet.slice(-12);
                          }
                        }

                        processScannedData
                          .call(self, trackingNumberToSet, {
                            TrackingServiceType: self.state.screensData.TrackingServiceType,
                            ScanAction: 'ScanPartnerProduct',
                          })
                          .then((processedData) => {
                            self.setScreensData(
                              {
                                TrackingNumberTyped: false,
                                TrackingNumber: trackingNumberToSet,
                                TrackingNumbers: [
                                  {
                                    //  ProductItemID:uuidv4(),
                                    TrackingNumber: trackingNumberToSet,
                                  },
                                ],
                              },
                              () => {
                                self.goToNextScreen(SCREENS.conditions_screen.key);
                              }
                            );
                          })
                          .catch((err) => {
                            self.setState({ pending: false });
                          });
                      }}
                    >
                      Continue
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          )}
        </div>
      );
    case SCREENS.tracking_number_quantity_screen.key:
      return (
        <div className={'screen-box tracking_number_quantity_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" text-center align-center">
              <div className="screen_title">
                {self.FeatureFlags.Processing3PLByManager
                  ? 'Please confirm the product and enter the quantity'
                  : 'Add new item'}
              </div>

              <Col xs={12} className="top20 text-left">
                <div className="pull-left font-size-18 right15   ">
                  <img
                    style={{ width: 100, height: '100%' }}
                    src={
                      _.get(this.state.screensData.CurrentPartnerProductData, 'OriginalImages.0.URL')
                        ? formatImageForBucket(
                            _.get(this.state.screensData.CurrentPartnerProductData, 'OriginalImages.0.URL')
                          )
                        : (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                          '/theme/assets/no-image-available.png'
                    }
                  />
                </div>

                <div className="font-size-18 pull-left top20    " style={{ VerticalAlign: 'middle' }}>
                  <div className="  ">{_.get(this.state.screensData, 'CurrentPartnerProductData.ProductName')} </div>
                  <div className="  ">
                    {'Condition: ' + _.get(this.state.screensData, 'CurrentPartnerProductData.Condition')}
                  </div>
                </div>
              </Col>
              {self.FeatureFlags.Processing3PLByManager && (
                <Col xs={12} className="top20 bot20 ">
                  <ControlLabel className=" pull-left top7 right15 purple ">Quantity to add:</ControlLabel>

                  <FormControl
                    type="number"
                    style={{ width: 80 }}
                    className="pull-left"
                    min="0"
                    max="500"
                    onChange={(e) => {
                      if (parseInt(e.target.value) > 500) {
                        self.props.displayMessage({
                          messageType: 'warning',
                          messageCode:
                            'Quantity cannot be higher than 500. Please process additional items separately.',
                        });
                        return;
                      }
                      self.setScreensData({ QuantityToAdd: e.target.value }, () => {});
                    }}
                    value={_.get(this.state.screensData, 'QuantityToAdd', 1)}
                    placeholder={''}
                  />
                </Col>
              )}
            </Col>
          </Row>
          <div className="top30    text-center">
            <Button
              data-testid="add-3pl-item-button"
              disabled={
                this.state.pending ||
                isNaN(_.get(this.state.screensData, 'QuantityToAdd', 0)) ||
                _.get(this.state.screensData, 'QuantityToAdd', 0) <= 0
              }
              className="btn btn-lg btn-primary set-width  "
              onClick={() => {
                if (this.state.pending) {
                  return;
                }
                var customData = {};

                customData.ProductCategories = prepareProductCategories.call(this, {
                  selectedGBGProduct: _.get(this.state.screensData, 'selectedGBGProduct', {}),
                  AllCategories: this.state.AllCategories,
                });

                if (parseInt(this.state.screensData.QuantityToAdd) > 500) {
                  self.props.displayMessage({
                    messageType: 'warning',
                    messageCode: 'Quantity cannot be higher than 500. Please process additional items separately.',
                  });
                  return;
                }
                var dataToSave = { QuantityToAdd: parseInt(this.state.screensData.QuantityToAdd) };

                self.setScreensData(dataToSave, () => {
                  self
                    .processPartnerProduct()
                    .then(() => {
                      self.resetScreensData({
                        resetScreensCallback: () => {
                          try {
                            BrowserPrint.getLocalDevices(
                              (deviceListData) => {
                                console.log('deviceListData 1', deviceListData);

                                self.setScreensData({
                                  printerChecked: true,
                                  selectedPrinter: _.get(deviceListData, ['printer', 0]),
                                });
                              },
                              (errorMessage) => {
                                console.log('errorMessage', errorMessage);
                                self.setScreensData({ printerChecked: true });
                                self.props.displayMessage({
                                  messageType: 'warning',
                                  messageCode:
                                    'Can not get data for a printer. ' +
                                    errorMessage +
                                    ' Please, check if printer is connected',
                                });
                              }
                            );
                          } catch (errorMessage) {
                            console.log(errorMessage);
                            self.props.displayMessage({
                              messageType: 'warning',
                              messageCode: 'Can not get data for a printer. Please, check if printer is connected',
                            });
                          }
                        },
                        fieldsToKeep: ['currentServiceRecord', 'CurrentPartnerProductData', 'nextProductNumber'],
                        nextScreen: SCREENS.barcode_printing_screen.key,
                      });
                    })
                    .catch((err) => {
                      self.setState({ pending: false });
                    });
                });
              }}
            >
              Save
            </Button>
          </div>
        </div>
      );
    case SCREENS.conditions_screen.key:
      const detailsHTML = (
        <div>
          <div className="font-size-17 top20 text-left set-width align-center text-bold">{'Condition Details:*'}</div>
          <div className="top5 align-center set-width">
            <FormControl
              value={_.get(this.state.screensData, 'Details', '')}
              componentClass="textarea"
              rows="4"
              placeholder=""
              onChange={(e) => {
                this.setScreensData({
                  Details: e.target.value,
                });
              }}
              type="text"
            />
          </div>
        </div>
      );

      const notesHTML = <div>{this.displayNotesTextInput()}</div>;

      const titleText = self.FeatureFlags.DeterministicCondition ? 'Optional Settings' : 'Please select the condition';

      const titleHTML = <div className="screen_title">{titleText}</div>;

      const continueButton = (
        <div className="top30    text-center">
          <Button
            data-testid="next-screen-button"
            disabled={this.state.pending}
            className="btn btn-lg btn-primary set-width"
            onClick={() => {
              var dataToSave = {
                Notes: _.get(this.state.screensData, ['Notes'], ''),
                Condition: _.get(this.state.screensData, 'Condition', -1),
                listingsFetched: false,
                Details: _.get(this.state.screensData, ['Details'], ''),
                GBGProductsFetched: false,
              };

              console.log('dataToSave', dataToSave);

              if (
                !_.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
                  return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                })
              ) {
                if (dataToSave.Condition == -1 && !self.FeatureFlags.DeterministicCondition) {
                  this.props.displayMessage({
                    messageType: 'warning',
                    messageCode: 'Please, specify product condition',
                  });
                  return false;
                }

                if (
                  _.includes(
                    [
                      _.find(config.conditionsData, { value: 'GentlyUsedMinorIssues' })['number'],
                      _.find(config.conditionsData, { value: 'Loved' })['number'],
                    ],
                    dataToSave.Condition
                  ) &&
                  !dataToSave.Details
                ) {
                  this.props.displayMessage({
                    messageType: 'warning',
                    messageCode: 'Please, specify product condition details',
                  });
                  return false;
                }
              }

              if (dataToSave.Condition == _.find(config.conditionsData, { value: 'Loved' })['number']) {
                /* do not save HotBuy for Loved condition */
                dataToSave.HotBuy = false;
              }

              self.setScreensData(dataToSave, function () {
                if (self.state.currentFlow == 'PostingFlow') {
                  if (_.get(self.state.screensData, ['productAction'], '') == 'AddPrelisting') {
                    if (_.get(self.state.screensData, 'selectedGBGProduct._id')) {
                      self.goToQualityCheckScreen(dataToSave, {
                        qualityChecksNotFoundScreen: SCREENS.fees_screen.key,
                      });
                    } else {
                      /* GBG Product Not Found */
                      self.goToNextScreen(SCREENS.categories_screen.key);
                    }
                  }
                } else {
                  if (dataToSave.Condition == 8) {
                    // What is condition 8, we don't know yet. DISPOSE is on
                    const { RMAProductsData = {}, GBGID } = self.state.screensData;

                    self.updateScreensData({
                      upToCurrentScreen: true,
                      callbackMethod: function () {
                        self.setState({ pending: true });
                        prepareDataForDonation
                          .call(self)
                          .then((dataToUpdate) => {
                            dataToUpdate.RMAProductsData = RMAProductsData;
                            dataToUpdate.GBGID = GBGID;
                            self.setScreensData(dataToUpdate, () => {
                              self.goToNextScreen(SCREENS.gbg_product_details_screen.key, {
                                screenDataToSet: { Condition: 5 },
                              }); /* use Gently Used for Donations */
                            });
                          })
                          .catch((err) => {
                            self.setState({ pending: false });
                            console.log('err', err);
                          });
                      },
                    });
                  } else {
                    // 4moms code
                    const { RMAProductsData = {}, selectedGBGProduct } = self.state.screensData;

                    if (
                      self.props.appData.FeatureFlags.RMAProductsSelectionScreenEnabled &&
                      RMAProductsData.sendRMAProductProcessedEvents
                    ) {
                      if (selectedGBGProduct) {
                        return self.goToNextScreen(SCREENS.gbg_product_details_screen.key);
                      }
                    }

                    self.goToNextScreen(SCREENS.gbg_product_selection_screen.key, {
                      nextScreenCallback: () => {
                        self.searchUPCInput && ReactDOM.findDOMNode(self.searchUPCInput).focus();

                        if (config.getEnvironmentName() == 'local' && !self.FeatureFlags.DeterministicCondition) {
                          self.searchProducts();
                        }
                      },
                    });
                  }
                }
              });
            }}
          >
            Continue
          </Button>
        </div>
      );

      return (
        <div className={'screen-box conditions_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row
            style={this.state.currentFlow == '3PLProcessingFlow' ? { minHeight: 220 } : {}}
            className="screen-content"
          >
            <Col xs={12} className="align-center text-center">
              {titleHTML}

              {this.displayConditionsList()}

              {!self.FeatureFlags.DeterministicCondition && detailsHTML}

              {this.state.currentFlow == '3PLProcessingFlow' && notesHTML}
            </Col>
          </Row>
          {continueButton}
        </div>
      );
    case SCREENS.item_failed_quality_check_screen.key:
      return (
        <div className={'screen-box item_failed_quality_check_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className="align-center text-center">
              <img
                style={{ width: 305, height: 305 }}
                src={
                  (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                  '/theme/assets/check-fail.png'
                }
              />
              <div className="screen_title">ITEM FAILED QUALITY CHECK</div>
              Please create Unable to Sell listing
              <div className="top30">
                <Button
                  data-testid="next-screen-button"
                  style={{ width: 250 }}
                  className="btn btn-lg quality-check-button"
                  onClick={() => {
                    self.setState({ pending: true });
                    prepareDataForDonation
                      .call(self)
                      .then((dataToUpdate) => {
                        if (self.state.currentFlow == '3PLProcessingFlow') {
                          dataToUpdate.TrackingNumbers = [
                            {
                              ...self.state.screensData.TrackingNumbers[0],
                              Disposition: 'salvage',
                            },
                          ];
                        }

                        if (
                          dataToUpdate.selectedGBGProduct.OriginalProductData &&
                          this.state.screensData.selectedGBGProduct.OriginalProductData
                        ) {
                          dataToUpdate.selectedGBGProduct.OriginalProductData.RetailProductPrice =
                            this.state.screensData.selectedGBGProduct.OriginalProductData.RetailProductPrice;
                        }

                        self.setScreensData(dataToUpdate, () => {
                          self.goToNextScreen(SCREENS.gbg_product_details_screen.key, {
                            screensToRemove: [
                              SCREENS.quality_checks_screen.key,
                              SCREENS.item_failed_quality_check_screen.key,
                            ],
                          });
                        });
                      })
                      .catch((err) => {
                        self.setState({ pending: false });
                      });
                  }}
                >
                  Create Unable To Sell
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );

    case SCREENS.instructions_screen.key:
      return (
        <div className={'screen-box instructions_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-center">
              <div className="screen_title">Uh oh...</div>
              <div className="screen_title">{'This item failed the quality checks. Our suggestion is to'}</div>

              {_.get(this.state.screensData, 'QualityCheckInstructions', []).length > 0 && (
                <div className="font-size-20 pink">
                  {instructionsToTextMap[_.get(this.state.screensData, 'QualityCheckInstructions.0.Action', '')].Text}
                </div>
              )}
              <div className="font-size-20  top30   purple">{'What would you like to do?'}</div>
              {_.filter(_.get(this.state.screensData, 'qualityCheckItems', []), (item) => {
                return item.checkedStatus == 'failed';
              }).length > 0 && (
                <div className="top30">
                  <Button
                    className="btn btn-lg btn-primary set-width "
                    onClick={() => {
                      self.setScreensData(
                        { currentQualityCheckRecord: _.first(this.state.screensData.qualityCheckItems) },
                        () => {
                          self.goToNextScreen(SCREENS.quality_checks_screen.key);
                        }
                      );
                    }}
                  >
                    Return to quality checks
                  </Button>
                </div>
              )}
              <div className="top30">
                <Button
                  disabled={this.state.pending}
                  className="btn btn-lg btn-primary set-width "
                  onClick={() => {
                    self.setScreensData({
                      selectedAction: 'Donation',
                      modalTitle: 'Are you sure you want to donate this item?',
                    });

                    self.setState({ showCustomDialogID: true });
                  }}
                >
                  Create donation listing
                </Button>
              </div>
              {(config.getEnvironmentName() == 'local' ||
                (self.state.currentFlow == 'PostingFlow' &&
                  'PartnerPurchased' ==
                    _.get(self.state.screensData, 'currentServiceRecord.SellerID.InventoryOwnership'))) && (
                <div className="top30">
                  <Button
                    className="btn btn-lg btn-primary set-width "
                    onClick={() => {
                      self.setScreensData({
                        selectedAction: 'TroubleshootingRoom',
                        modalTitle: 'Are you sure you want to check this item into Troubleshooting Room?',
                      });

                      self.setState({ showCustomDialogID: true });
                    }}
                  >
                    {' '}
                    Check into Troubleshooting Room
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </div>
      );
    case SCREENS.instructions_details_screen.key:
      return (
        <div className={'screen-box instructions_details_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className="   text-center align-center">
              <div className="screen_title">Add a red sticker and internal comment</div>

              <img
                className="top30  "
                style={{ width: 100, height: 100 }}
                src={
                  (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                  '/theme/assets/red_sticker.png'
                }
              />
              <div className="font-size-17   top20 text-left set-width align-center text-bold">
                {'Internal Comment:*'}
              </div>
              <div className="top5 set-width" style={{ margin: '0 auto' }}>
                <FormControl
                  value={_.get(this.state.screensData, 'InternalComment', '')}
                  componentClass="textarea"
                  placeholder=""
                  onChange={(e) => {
                    self.setScreensData({ InternalComment: e.target.value });
                  }}
                  type="text"
                />
              </div>
              <div className="clearfix set-width  top15  align-center ">
                {_.size(_.get(this.state.screensData, 'instructionsImages', [])) == 0 &&
                _.isUndefined(self.state.screensData.displayUploadInstructionImages) ? (
                  <Button
                    className="pull-left btn btn-primary  "
                    type="button"
                    onClick={(e) => {
                      self.setScreensData({ displayUploadInstructionImages: e.target.value });
                    }}
                  >
                    Add image
                  </Button>
                ) : (
                  <ImageList
                    {...this.props}
                    currentRecord={{ _id: self.state.screensData.ProductID }}
                    model={'products'}
                    deleteImage={(imageToDelete) => {
                      self.setScreensData({ instructionsImages: [] });
                      return Promise.resolve(true);
                    }}
                    doNotSaveImageInRecord={true}
                    uploadImageMessage={''}
                    uploadImagesSuccess={(uploadedImages) => {
                      console.log('uploadedImages', uploadedImages);
                      if (!_.get(uploadedImages, 0)) {
                        return;
                      }
                      self.setScreensData({ instructionsImages: uploadedImages });
                    }}
                    maximumNumberOfImagesToUpload={1}
                    images={_.get(self.state.screensData, 'instructionsImages', [])}
                  ></ImageList>
                )}
              </div>
              <div className=" top30 ">
                <Button
                  data-testid="next-screen-button"
                  disabled={this.state.pending || _.get(this.state.screensData, 'InternalComment', '') == ''}
                  className="btn btn-lg btn-primary set-width "
                  onClick={() => {
                    if (this.state.pending) {
                      return;
                    }
                    var dataToUpdate = {};
                    if (
                      this.state.screensData.InternalComment ||
                      _.get(this.state.screensData, ['instructionsImages', 0, 'URL'])
                    ) {
                      dataToUpdate.Comments = [
                        {
                          CommentText: this.state.screensData.InternalComment
                            ? this.state.screensData.InternalComment
                            : 'Image',
                          CommentImageURL: _.get(this.state.screensData, ['instructionsImages', 0, 'URL'], undefined),
                          SentByUserID: base64ToHex(_.get(this.props.userReducer, 'user._id')),
                          SentByUserName:
                            _.get(this.props.userReducer, 'user.firstName') +
                            (_.get(this.props.userReducer, 'user.lastName')
                              ? ' ' + _.get(this.props.userReducer, 'user.lastName')
                              : ''),
                        },
                      ];
                    }

                    self.setScreensData(dataToUpdate, () => {
                      self.goToNextScreen(SCREENS.fees_screen.key);
                    });
                  }}
                >
                  Continue
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
    case SCREENS.categories_screen.key:
      return (
        <div className={'screen-box categories_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content  ">
            <Col xs={6} className="set-width align-center text-center">
              <div className="screen_title">{'Select one or more categories where you could find this gear:'}</div>

              {this.displayCategoryList()}
            </Col>
          </Row>
          <div className="top30    text-center">
            <Button
              data-testid="next-screen-button"
              className="btn btn-lg btn-primary set-width  "
              onClick={() => {
                var dataToSave = {};
                dataToSave.selectedCategories = getSelectedCategories.call(this, this.state.AllCategories, true);
                if (!_.size(dataToSave.selectedCategories)) {
                  this.props.displayMessage({
                    messageType: 'warning',
                    messageCode: 'Please, add at least one category for the product',
                  });
                  return false;
                }
                dataToSave.ProductCategories = prepareProductCategories.call(this, {
                  selectedGBGProduct: _.get(this.state.screensData, 'selectedGBGProduct', {}),
                  selectedCategories: dataToSave.selectedCategories,
                  AllCategories: this.state.AllCategories,
                });
                var customParams = {
                  qualityChecksNotFoundScreen: SCREENS.fees_screen.key,
                };
                self.goToQualityCheckScreen(dataToSave, customParams);
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      );
    case 'quality_checks_screen':
      return (
        <div className={'screen-box quality_checks_screen'}>
          {displayPrevNextButtons.call(this, {})}
          {self.FeatureFlags.DeterministicCondition && (
            <ConditionScaleComponent
              conditionRating={this.state.screensData.currentConditionRating}
              sellerType={getSellerType.call(this)}
            ></ConditionScaleComponent>
          )}
          {self.FeatureFlags.DeterministicCondition && this.state.screensData.GBGProductImage && (
            <ViewImageComponent imageURL={this.state.screensData.GBGProductImage}></ViewImageComponent>
          )}
          <Row className="screen-content">
            <Col xs={6} className="align-center text-center">
              {self.FeatureFlags.DeterministicCondition ? (
                <QualityCheckList
                  featureFlags={self.FeatureFlags}
                  setScreensData={(data) => self.setScreensData(data)}
                  qualityCheckAnswerHandler={(foundItemIndex, answer) =>
                    qualityCheckAnswerHandler.call(self, foundItemIndex, answer)
                  }
                  screensData={this.state.screensData}
                ></QualityCheckList>
              ) : (
                displayQualityCheckItems.call(self, this.state.screensData)
              )}
            </Col>
            {displayCustomDialog.call(this, {
              cancelButtonTitle: 'Cancel',
              buttonTitle: 'Ok',
              cancelActionHandler: () => {},
              confirmActionHandler: (data) => {
                self.state.screensData.postingModalConfirmHandler();
              },
              modalTitle: self.state.screensData.postingModalTitle,
              dialogID: 'PostingModalDialog',
            })}
          </Row>
          <div className="top30    text-center">
            {config.getEnvironmentName() == 'local' && (
              <Button
                data-testid="next-screen-button"
                className="btn btn-lg btn-primary set-width "
                onClick={() => {
                  var dataToSave = prepareDataForScreen.call(self),
                    nextScreen = SCREENS.fees_screen.key;
                  if (_.size(_.get(dataToSave, 'QualityCheckInstructions', [])) > 0) {
                    nextScreen = SCREENS.instructions_screen.key;
                  }

                  const { CurrentPartnerProductData = {} } = this.state.screensData;

                  if (self.state.currentFlow == '3PLProcessingFlow' && CurrentPartnerProductData._id) {
                    nextScreen = SCREENS.location_scanning_screen.key;
                  }

                  if (self.state.screensData.inboundProductId) {
                    nextScreen = SCREENS.inbound_rebound_add_inventory.key;
                  }

                  self.setScreensData(dataToSave, () => {
                    self.goToNextScreen(nextScreen);
                  });
                }}
              >
                Continue
              </Button>
            )}
          </div>
        </div>
      );
    case SCREENS.product_options_screen.key:
      return (
        <div className={'screen-box product_options_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col md={9} xs={12} className="align-center text-center top10">
              <div className="screen_title">{'Please, select the item you are selling'}</div>
              {this.state.screensData.searchAPIProductsFetched && (
                <div className="top20">
                  {this.state.screensData.searchAPIProducts.length == 0 ? (
                    <div className="messageBox font-size-19">{'No matching products found'}</div>
                  ) : (
                    <div>
                      <BootstrapTable
                        data={_.get(this.state.screensData, 'searchAPIProducts', [])}
                        ref="table"
                        hover={true}
                        style={{ maxHeight: 500 }}
                        bordered={false}
                        //  striped={true}
                        // options={{
                        //     onRowClick: function(row) {
                        //         console.log('on row click', row  );
                        // }}  }
                      >
                        <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={true} hiddenOnInsert>
                          Id
                        </TableHeaderColumn>

                        <TableHeaderColumn
                          width="60px"
                          editable={false}
                          columnClassName="search-api-product-column"
                          dataFormat={customFormatter}
                          dataField="ProductItemQuantity"
                          formatExtraData={{
                            path: ['getObject'],
                            format: (item) => {
                              return (
                                <Row className="  pleft10 ptop15 pbot10 pright10" style={{}}>
                                  <Col xs={8} className="text-left">
                                    <div className="pull-left right15   ">
                                      <img
                                        style={{ width: 100, height: '100%' }}
                                        src={
                                          _.get(item, 'img') && _.get(item, 'img') !== 'image_not_found'
                                            ? _.get(item, 'img')
                                            : (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                                              '/theme/assets/no-image-available.png'
                                        }
                                      />
                                      <div className="top10 font-size-18 text-center">{_.get(item, 'price')} </div>
                                    </div>
                                    <div>
                                      <a target="_blank" href={_.get(item, 'OriginalUrl')}>
                                        {_.get(item, 'name')}{' '}
                                      </a>
                                    </div>
                                  </Col>
                                  <Col xs={4}>
                                    <Button
                                      className="btn btn-lg btn-primary custom-btn "
                                      onClick={() => {
                                        var dataToSave = {},
                                          nextScreen = SCREENS.quality_checks_screen.key;
                                        dataToSave.OriginalPrice = item.price == 'price_not_found' ? 0 : item.price;
                                        dataToSave.selectedSearchAPIProduct = item;
                                        if (_.get(item, 'searchType') == 'GoogleSerpAPI') {
                                          dataToSave.selectedSearchAPIProduct.GoogleSerpAPI = true;
                                        } else {
                                          /* Amazon product */
                                          dataToSave.images = _.map(self.state.screensData.images, _.clone);
                                          var externalImageIndex = _.findIndex(dataToSave.images, function (image) {
                                            return (
                                              _.get(image, ['type'], '') == 'External' &&
                                              _.get(image, ['CustomImageData', 'Source'], '') == 'AmazonProduct'
                                            );
                                          });
                                          var GBGProductImage = _.find(dataToSave.images, function (image) {
                                            return _.get(image, ['CustomImageData', 'Source'], '') == 'GBGProductImage';
                                          });
                                          if (
                                            item.img !== 'image_not_found' &&
                                            _.get(dataToSave.images, [externalImageIndex, 'fullUri'], 'n/a') !==
                                              item.img
                                          ) {
                                            if (externalImageIndex !== -1) {
                                              _.pullAt(dataToSave['images'], [externalImageIndex]);
                                              /* delete previous external image */
                                            }
                                            if (!GBGProductImage) {
                                              /* add External image only if GBGProduct image is not yet added*/
                                              dataToSave['images'].push({
                                                fullUri: item.img,
                                                uploadProgress: 1,
                                                imageID: generateMongoObjectID(),
                                                type: 'External',
                                                CustomImageData: { Source: 'AmazonProduct' },
                                              });
                                            }
                                          }

                                          dataToSave.selectedSearchAPIProduct.AmazonProduct = true;
                                        }
                                        if (self.state.currentFlow == 'PostingFlow') {
                                          nextScreen = SCREENS.conditions_screen.key;

                                          if (self.FeatureFlags.DeterministicCondition) {
                                            nextScreen = SCREENS.quality_checks_screen.key;
                                          }
                                        }
                                        if (nextScreen == SCREENS.quality_checks_screen.key) {
                                          self.goToQualityCheckScreen(dataToSave);
                                        } else {
                                          self.setScreensData(dataToSave, () => {
                                            self.goToNextScreen(nextScreen);
                                          });
                                        }
                                      }}
                                    >
                                      {' '}
                                      <div>
                                        <div className="font-size-15">That's it</div>
                                        <div className="font-size-15">(or it’s pretty darn close)</div>
                                      </div>
                                    </Button>
                                  </Col>
                                </Row>
                              );
                            },
                          }}
                          dataAlign="center"
                        >
                          {''}
                        </TableHeaderColumn>
                      </BootstrapTable>
                      <div className="align-center top25">
                        <Button
                          className="  top25   btn btn-lg btn-primary custom-btn set-width "
                          onClick={() => {
                            var dataToSave = {},
                              nextScreen = SCREENS.quality_checks_screen.key;
                            if (self.state.currentFlow == 'PostingFlow') {
                              nextScreen = SCREENS.conditions_screen.key;

                              if (self.FeatureFlags.DeterministicCondition) {
                                nextScreen = SCREENS.quality_checks_screen.key;
                              }
                            }
                            if (self.state.screensData.useSearchAPI == 'SerpAPI') {
                              if (nextScreen == SCREENS.quality_checks_screen.key) {
                                self.goToQualityCheckScreen(dataToSave);
                              } else {
                                self.setScreensData(dataToSave, () => {
                                  self.goToNextScreen(nextScreen);
                                });
                              }
                            } else {
                              self.setScreensData({ useSearchAPI: 'SerpAPI' }, () => {
                                return searchProductsWithAPI.call(self).then((searchDataResponse) => {
                                  console.log('SerpAPI', searchDataResponse);
                                  _.extend(dataToSave, searchDataResponse);

                                  if (_.size(_.get(dataToSave, 'searchAPIProducts', [])) == 0) {
                                    if (nextScreen == SCREENS.quality_checks_screen.key) {
                                      self.goToQualityCheckScreen(dataToSave);
                                    } else {
                                      self.setScreensData(dataToSave, () => {
                                        self.goToNextScreen(nextScreen);
                                      });
                                    }
                                  } else {
                                    self.setScreensData(dataToSave);
                                  }
                                });
                              });
                            }
                          }}
                        >
                          {self.state.screensData.searchAPIProducts.length > 0 &&
                          self.state.screensData.useSearchAPI !== 'SerpAPI'
                            ? 'Nope, none of these...'
                            : 'Continue'}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </div>
      );
    case SCREENS.barcode_printing_screen.key:
      return (
        <div className={'screen-box barcode_printing_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <PrintingScreen
            {...this.props}
            setScreensData={(dataToUpdate) => self.setScreensData(dataToUpdate)}
            {..._.pick(this.state, ['screensData', 'pending', 'currentFlow', 'showModal'])}
            generateBarcodes={(params) => generateBarcodesInPrintingScreen.call(self, params)}
            displayProductSKUs={() => displayProductSKUs.call(self)}
            ProductsSettingsData={self.ProductsSettingsData}
            updateParentComponentState={(dataToUpdate) => {
              self.setState(dataToUpdate);
            }}
            resetScreensData={() => self.resetScreensData()}
            setBarcodeSVG={(barcodeSVG) => {
              if (barcodeSVG && !self.barcodeSVG) {
                self.barcodeSVG = barcodeSVG;
              }
            }}
          ></PrintingScreen>
        </div>
      );
    case SCREENS.pallet_confirmation_screen.key:
      return (
        <div className={'screen-box pallet_confirmation_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-left top20">
              <div className="purple font-size-21 text-center text-bold   top20  ">
                {'Pallet ' + _.get(this.state.screensData, ['CurrentProductData', 'PalletID', 'Notes'], '')}
              </div>
              <div className="  font-size-17    top20  ">Please confirm receipt of:</div>
              <div className="purple font-size-17 text-bold   top10  ">
                {_.get(this.state.screensData, ['CurrentProductData', 'ProductName'], '')}
              </div>

              <div className="purple font-size-17 text-bold   top10  ">
                {'Quantity: ' +
                  _.get(this.state.screensData, ['CurrentProductData', 'ProductVariants', 0, 'Quantity'], '')}
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={6} className="set-width flex-box space-around align-center text-left top30">
              <Button
                disabled={this.state.pending}
                style={{ width: 100 }}
                className="btn btn-lg btn-default  grayed   "
                onClick={() => {
                  if (this.state.pending) {
                    return;
                  }
                  self.goToNextScreen(SCREENS.pallet_dispute_screen.key);
                }}
              >
                {' '}
                NO
              </Button>
              <Button
                disabled={this.state.pending}
                style={{ width: 100 }}
                className="btn btn-lg btn-primary  "
                onClick={() => {
                  if (this.state.pending) {
                    return;
                  }
                  self.setState({
                    pending: true,
                  });

                  self.props
                    .makeRequest(
                      { PalletProductData: { PalletProductStatus: 'Checked' } },
                      {
                        type: 'patch',
                        endpoint: '/products/' + encodeURIComponent(self.state.screensData.CurrentProductData._id),
                      }
                    )
                    .then(function (response) {
                      self.resetScreensData({
                        fieldsToKeep: ['BarcodeNumber'],
                        nextScreen: SCREENS.posting_pallet_product_screen.key,
                      });
                    })
                    .catch(function (error) {});
                }}
              >
                YES
              </Button>
            </Col>
          </Row>

          <div className="top30    text-center">
            <Button
              disabled={this.state.pending}
              style={{ width: 290 }}
              className="btn btn-lg btn-primary  "
              onClick={() => {
                if (this.state.pending) {
                  return;
                }
                self.setScreensData(
                  {
                    palletProductsToAdd: [
                      {
                        ProductName: _.get(self.state.screensData, ['CurrentProductData', 'ProductName'], ''),
                        Quantity: _.get(
                          self.state.screensData,
                          ['CurrentProductData', 'ProductVariants', 0, 'Quantity'],
                          ''
                        ).toString(),
                      },
                    ],
                  },
                  () => {
                    self.goToNextScreen(SCREENS.pallet_product_variation_screen.key);
                  }
                );
              }}
            >
              <div>
                <div>Yes</div>
                <div>(but need to add variation(s))</div>
              </div>
            </Button>
          </div>
        </div>
      );
    case SCREENS.pallet_dispute_screen.key:
      return (
        <div className={'screen-box pallet_dispute_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-left top20">
              <div className="purple font-size-21 text-center text-bold   top20  ">{'Dispute'}</div>

              <div className="clearfix purple font-size-17   text-bold  bot20 top20  ">
                <div className="bot10"> {'Please upload photos (of entire pallet if missing)'}</div>

                {(_.size(_.get(this.state.screensData, 'palletImages', [])) > 0 ||
                  self.state.screensData.displayUploadPalletImages) && (
                  <ImageList
                    {...this.props}
                    displayUploadImageBox={self.state.screensData.displayUploadPalletImages}
                    currentRecord={{ _id: self.state.screensData.CurrentProductData._id }}
                    model={'products'}
                    deleteImage={(imageToDelete) => {
                      console.log('imageToDelete', imageToDelete);
                      var imageToDeleteIndex = _.findIndex(_.get(self.state.screensData, 'palletImages', []), {
                        _id: imageToDelete._id,
                      });
                      console.log('imageToDeleteIndex', imageToDeleteIndex);
                      if (imageToDeleteIndex == -1) {
                        return;
                      }
                      this.setScreensData({
                        palletImages: [
                          ...self.state.screensData.palletImages.slice(0, imageToDeleteIndex),
                          ...self.state.screensData.palletImages.slice(imageToDeleteIndex + 1),
                        ],
                      });
                      deleteImagesFromS3.call(self, [imageToDelete.URL]);
                      return Promise.resolve(true);
                    }}
                    doNotSaveImageInRecord={true}
                    uploadImageMessage={''}
                    uploadImagesSuccess={(uploadedImages) => {
                      console.log('uploadedImages', uploadedImages);
                      if (!_.get(uploadedImages, 0)) {
                        return;
                      }
                      self.setScreensData({
                        displayUploadPalletImages: false,
                        palletImages: _.concat(_.get(self.state.screensData, 'palletImages', []), uploadedImages),
                      });
                    }}
                    maximumNumberOfImagesToUpload={10}
                    images={_.get(self.state.screensData, 'palletImages', [])}
                  ></ImageList>
                )}
                {!self.state.screensData.displayUploadPalletImages && (
                  <div className=" top15   ">
                    <Button
                      style={{ width: 150 }}
                      className="btn btn-lg btn-primary   "
                      onClick={() => {
                        self.setScreensData({ displayUploadPalletImages: true });
                      }}
                    >
                      Add Photo
                    </Button>
                  </div>
                )}
              </div>
              <div className="clearfix purple font-size-17  text-bold   top20  ">{'Provide reason code:'}</div>
              {this.renderReasonCodes()}
              <div className="clearfix purple font-size-17   text-bold   top20  ">
                Enter received quantity:
                <FormControl
                  style={{ width: 60 }}
                  value={_.get(this.state.screensData, 'ReceivedQuantity', '')}
                  onChange={(e) => {
                    self.setScreensData({ ReceivedQuantity: e.target.value });
                  }}
                  className="pull-right "
                  type="text"
                />
              </div>
              <div className="top30 set-width">
                <FormControl
                  value={_.get(this.state.screensData, 'PalletProductNotes', '')}
                  componentClass="textarea"
                  placeholder="Enter notes"
                  onChange={(e) => {
                    self.setScreensData({ PalletProductNotes: e.target.value });
                  }}
                  type="text"
                />
              </div>
            </Col>
          </Row>

          <div className="top30    text-center">
            <Button
              disabled={this.state.pending}
              style={{ width: 290 }}
              className="btn btn-lg btn-primary  "
              onClick={() => {
                if (this.state.pending) {
                  return;
                }
                updatePalletProduct.call(self);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      );
    case SCREENS.pallet_product_variation_screen.key:
      var totalQuantity = _.reduce(
        _.get(this.state.screensData, 'palletProductsToAdd', []),
        function (total, item) {
          return (total += parseInt(item.Quantity));
        },
        0
      );
      if (isNaN(totalQuantity)) {
        totalQuantity = '';
      }
      return (
        <div className={'screen-box pallet_dispute_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-left top20">
              <div className="purple font-size-21 text-center text-bold   top20  ">{'Add SKU Variation'}</div>

              <div className="clearfix   purple font-size-18   text-bold  bot20 top20  ">
                <div style={{ width: '80%' }} className="  pull-left">
                  {' '}
                  {'Name of item'}
                </div>
                <div style={{ width: 40 }} className=" text-center  pull-right">
                  {' '}
                  {'#'}
                </div>
              </div>
              {_.get(this.state.screensData, 'palletProductsToAdd', []).map((item, index) => (
                <div key={index} className="clearfix text-center purple font-size-17    bot20 top20  ">
                  <FormControl
                    className=" pull-left"
                    type="text"
                    style={{ width: '80%' }}
                    value={item.ProductName}
                    onChange={(e) => {
                      self.setScreensData({
                        palletProductsToAdd: [
                          ...self.state.screensData.palletProductsToAdd.slice(0, index),
                          { ...self.state.screensData.palletProductsToAdd[index], ['ProductName']: e.target.value },
                          ...self.state.screensData.palletProductsToAdd.slice(index + 1),
                        ],
                      });
                    }}
                    componentClass="textarea"
                    placeholder=" "
                  />
                  <FormControl
                    className="  pull-right"
                    type="text"
                    style={{ width: 40 }}
                    value={item.Quantity}
                    onChange={(e) => {
                      this.setScreensData({
                        palletProductsToAdd: [
                          ...this.state.screensData.palletProductsToAdd.slice(0, index),
                          { ...this.state.screensData.palletProductsToAdd[index], ['Quantity']: e.target.value },
                          ...this.state.screensData.palletProductsToAdd.slice(index + 1),
                        ],
                      });
                    }}
                    placeholder=" "
                  />
                </div>
              ))}
              <div className="clearfix  top10  ">
                <div className="   pull-left top10">
                  <FaPlusCircle
                    style={{ color: Colors.lightBlue, position: 'relative', top: -2 }}
                    className="  font-size-25 cursor-pointer  "
                    onClick={() => {
                      self.setScreensData({
                        palletProductsToAdd: self.state.screensData.palletProductsToAdd.concat([
                          {
                            ProductName: _.get(self.state.screensData, ['CurrentProductData', 'ProductName'], ''),
                            Quantity: '1',
                          },
                        ]),
                      });
                    }}
                  />
                  <span
                    onClick={() => {
                      self.setScreensData({
                        palletProductsToAdd: self.state.screensData.palletProductsToAdd.concat([
                          {
                            ProductName: _.get(self.state.screensData, ['CurrentProductData', 'ProductName'], ''),
                            Quantity: '1',
                          },
                        ]),
                      });
                    }}
                    className="left10  font-size-20 purple cursor-pointer  "
                  >
                    Add More
                  </span>
                </div>
                {totalQuantity !== '' && (
                  <div className=" font-size-20  pull-right top10">
                    <span>{'Total: '}</span>
                    <span className="pink">{totalQuantity}</span>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <div className="top30    text-center">
            <Button
              disabled={totalQuantity == '' || this.state.pending}
              style={{ width: 290 }}
              className="btn btn-lg btn-primary  "
              onClick={() => {
                var filteredPalletProductsToAdd = _.reject(
                  [..._.get(this.state.screensData, 'palletProductsToAdd', [])],
                  (item) => {
                    return item.ProductName == '';
                  }
                );
                if (_.size(filteredPalletProductsToAdd) == 0) {
                  return self.props.displayMessage({
                    messageType: 'warning',
                    messageCode: 'Please, specify at least one variation',
                  });
                }
                this.setScreensData({ palletProductsToAdd: filteredPalletProductsToAdd }, function () {
                  processVariationsForPallets.call(self);
                });
              }}
            >
              Save
            </Button>
          </div>
        </div>
      );
    case SCREENS.posting_pallet_product_screen.key:
      return (
        <div className={'screen-box posting_pallet_product_screen'}>
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-left top20">
              <div className="purple font-size-21 text-center text-bold   top20  ">{'Pallet Product Confirmed'}</div>
              <div className="top30    text-center">
                <Button
                  style={{ width: 290 }}
                  className="btn btn-lg btn-primary  "
                  onClick={() => {
                    var activityType = 'PostingWarehouse';
                    // if (_.get(this.props.User, 'contractor._id')) {
                    //      if (config.getEnvironmentName() !== 'local1') {
                    //         this.setState({
                    //             activitiesListModalVisible: false,
                    //             activityExpectedTimeModalVisible: true,
                    //             timeTrackingActivityStartedCallback: () => {
                    //
                    //
                    //             },
                    //             activityType: activityType
                    //         })
                    //         console.log('start activity',);
                    //      }
                    //  }
                    // if (_.get(this.props.pricingNavState.data, ['CurrentProductData','ProductVariants',0,'Quantity'],0) >1){
                    //     dataToUpdate.CurrentProductData =_.extend({...self.props.pricingNavState.data.CurrentProductData}, {
                    //         ConfirmPalletProductQuantity: _.get(this.props.pricingNavState.data, ['CurrentProductData','ProductVariants',0,'Quantity'],'')
                    //     })
                    // }

                    self.resetScreensData({
                      fieldsToKeep: ['BarcodeNumber'],
                      resetScreensCallback: () => {
                        processScannedData
                          .call(self, self.state.screensData.BarcodeNumber, {
                            ScanAction: 'ScanBarcodeNumber',
                          })
                          .then(() => {})
                          .catch((err) => {
                            self.setState({ pending: false });
                          });
                      },
                    });
                  }}
                >
                  Post product now
                </Button>
              </div>
              <div className="top30    text-center">
                <Button
                  style={{ width: 290 }}
                  className="btn btn-lg btn-primary  "
                  onClick={() => {
                    self.resetScreensData();
                  }}
                >
                  Check in more products
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
    case SCREENS.location_scanning_screen.key:
      if (this.props.appData.FeatureFlags.WarehouseLocationScreenDisabled) {
        return (
          <div className={'screen-box location_scanning_screen'}>
            {displayPrevNextButtons.call(this, {})}
            <LocationScanningScreen
              {...this.props}
              setScreensData={(dataToUpdate, callback) =>
                this.setScreensData(dataToUpdate, () => {
                  callback && callback();
                })
              }
              {..._.pick(this.state, ['screensData', 'pending'])}
              updateParentComponentState={(dataToUpdate) => {
                self.setState(dataToUpdate);
              }}
              submitHandler={() => {
                const { CurrentPartnerProductData = {} } = self.state.screensData;
                if (CurrentPartnerProductData._id) {
                  self.goToNextScreen(SCREENS.tracking_number_quantity_screen.key);
                } else {
                  self.goToNextScreen(SCREENS.confirmation_screen.key);
                }
              }}
              setWarehouseLocationInput={(warehouseLocationInput) => {
                self.warehouseLocationInput = warehouseLocationInput;
              }}
            ></LocationScanningScreen>
          </div>
        );
      }
      return (
        <div className={'screen-box location_scanning_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className=" align-center text-center">
              <div className="green font-size-27 text-bold   bot20  ">Listing Complete!</div>
              <div className="font-size-22 purple">
                {this.state.currentFlow == '3PLProcessingFlow' &&
                _.get(self.state.screensData, 'CurrentPartnerProductData._id', '')
                  ? 'Please scan the item into Put Away area'
                  : 'Please scan the item into the picture area'}
              </div>
              <img
                className=" top30 bot30"
                src={
                  (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                  (_.get(self.state.screensData, 'CurrentPartnerProductData._id', '')
                    ? '/theme/assets/put_away_area.png'
                    : '/theme/assets/photo_area.png')
                }
              />
              <div className="top30 set-width" style={{ margin: '0 auto' }}>
                <FormControl
                  data-testid="add-location-textarea"
                  value={_.get(this.state.screensData, 'LocationInWarehouse', '')}
                  componentClass="textarea"
                  ref={(warehouseLocationInput) => {
                    self.warehouseLocationInput = warehouseLocationInput;
                  }}
                  placeholder=""
                  onKeyPress={(e) => {
                    self.setScreensData({ LocationInWarehouseTyped: true });
                  }}
                  onChange={(e) => {
                    console.log('onChange  e.target.value', e.target.value);
                    // if (_.get(self.state.screensData, 'LocationInWarehouseTyped') && !config.checkAccessRights.call(this,{ resources:['problem_solver_access',]})) {
                    //     return
                    // }
                    var textValue = e.target.value;
                    const { LocationInWarehouse = '' } = this.state.screensData;
                    var dataToUpdate = { LocationInWarehouse: e.target.value };
                    if (LocationInWarehouse.length > e.target.value.length) {
                      dataToUpdate.LocationInWarehouseTyped = true;
                    }

                    if (e.target.value.toLowerCase().includes('box')) {
                      return self.props.displayMessage({
                        messageType: 'warning',
                        messageCode: 'Sorry, locations with "box" word can be used only in the app',
                      });
                    }

                    self.setScreensData(dataToUpdate, () => {
                      setTimeout(() => {
                        const { LocationInWarehouseTyped = false } = self.state.screensData;
                        console.log('LocationInWarehouseTyped', LocationInWarehouseTyped);
                        if (!LocationInWarehouseTyped) {
                          locationInWarehouseTextCallback.call(self);
                        } else if (textValue == '') {
                          self.setScreensData({ LocationInWarehouseTyped: false });
                        }
                      }, 200);
                    });
                    //   }
                  }}
                  type="text"
                />
              </div>
            </Col>
          </Row>
          <div className="top30    text-center">
            <Button
              data-testid="next-screen-button"
              disabled={!this.state.screensData.LocationInWarehouse || this.state.pending}
              className="btn btn-lg btn-primary set-width "
              onClick={() => {
                if (this.state.pending) {
                  return;
                }
                this.setState({ pending: true });
                this.setScreensData({ LocationInWarehouseTyped: false });
                if (self.state.currentFlow == '3PLProcessingFlow') {
                  console.log(
                    'CurrentPartnerProductData',
                    _.get(self.state.screensData, 'CurrentPartnerProductData._id')
                  );
                  if (_.get(self.state.screensData, 'CurrentPartnerProductData._id')) {
                    self.goToNextScreen(SCREENS.tracking_number_quantity_screen.key);
                  } else {
                    self.goToNextScreen(SCREENS.confirmation_screen.key);
                  }
                } else {
                  self.goToNextScreen(SCREENS.confirmation_screen.key);
                }
              }}
            >
              Add Location
            </Button>
          </div>
        </div>
      );
    case SCREENS.fees_screen.key:
      var ShippableSwitcherFixed =
        _.size(
          _.intersection(_.get(this.state.screensData, ['selectedGBGProduct', 'GBGProductTags'], []), [
            'Shipping Options_Notshippable',
            'Shipping Options_Shippable',
          ])
        ) > 0;

      if (this.props.appData.FeatureFlags.UseFeesScreen) {
        return (
          <div className={'screen-box fees_screen'}>
            {displayPrevNextButtons.call(this, {})}
            <FeesScreen
              {...self.props}
              setScreensData={(dataToUpdate, callback) =>
                this.setScreensData(dataToUpdate, () => {
                  callback && callback();
                })
              }
              {..._.pick(self.state, ['screensData', 'pending', 'images'])}
              goToNextScreenCallback={(dataToSave) => {
                const nextScreen = getNextScreenName.call(self, {
                  currentScreen: SCREENS.fees_screen.key,
                });
                self.setScreensData(dataToSave, () => {
                  self.goToNextScreen(nextScreen);
                });
              }}
              updateParentComponentState={(dataToUpdate) => {
                self.setState(dataToUpdate);
              }}
              renderFeeList={(feesToRender) => {
                return renderFeeList.call(self, self.state.screensData, feesToRender);
              }}
            ></FeesScreen>
          </div>
        );
      }
      return (
        <div className={'screen-box fees_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className="align-center   text-center">
              <div className="screen_title">{'A few more optional questions'}</div>

              {this.state.screensData.Condition !== _.find(config.conditionsData, { value: 'Loved' })['number'] &&
                !_.get(this.state.screensData, 'GBGProductFound') &&
                !_.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
                  return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                }) && (
                  <div className="top20 text-left ">
                    <Checkbox
                      onChange={() => {
                        this.setScreensData({ HotBuy: !this.state.screensData.HotBuy });
                      }}
                      checked={this.state.screensData.HotBuy}
                    >
                      <span className="text-bold">Hot Buy</span>
                    </Checkbox>
                  </div>
                )}
              {!_.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
                return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
              }) && (
                <div>
                  <div className="text-bold font-size-17 bot5 top20 text-left">Fees</div>
                  {renderFeeList.call(self, this.state.screensData, allFeesList)}
                </div>
              )}

              {!_.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
                return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
              }) && (
                <div className="top20 text-left ">
                  <span
                    style={{
                      position: 'relative',
                      top: '-2px',
                    }}
                    onClick={(option) => {
                      if (!this.state.screensData.overrideShippingStatus && ShippableSwitcherFixed) {
                        return;
                      }
                      this.setScreensData({ Shippable: !_.get(this.state.screensData, 'Shippable', false) });
                    }}
                    className={classNames('text-bold font-size-17 right15  text-left', {
                      'cursor-pointer': this.state.screensData.overrideShippingStatus || !ShippableSwitcherFixed,
                    })}
                  >
                    Shippable
                  </span>
                  <Toggle
                    disabled={!this.state.screensData.overrideShippingStatus && ShippableSwitcherFixed}
                    onClick={(option) => {
                      this.setScreensData({ Shippable: option });
                    }}
                    style={
                      _.get(this.state.screensData, 'Shippable') == 'not_specified'
                        ? { width: 100, height: 30, backgroundColor: '#ddd', borderColor: '#ddd' }
                        : { width: 100, height: 30 }
                    }
                    on={'Yes'}
                    off={_.get(this.state.screensData, 'Shippable') == 'not_specified' ? 'Not set' : 'No'}
                    onClassName={'selected-state'}
                    offClassName={
                      _.get(this.state.screensData, 'Shippable') == 'not_specified' ? 'indeterminate-state' : ''
                    }
                    offstyle={'danger'}
                    active={
                      _.get(this.state.screensData, 'Shippable') == 'not_specified'
                        ? false
                        : _.get(this.state.screensData, 'Shippable', false)
                    }
                  />

                  {config.checkAccessRights.call(this, { resources: ['problem_solver_access'] }) &&
                    ShippableSwitcherFixed && (
                      <Checkbox
                        onChange={() => {
                          this.setScreensData({
                            overrideShippingStatus: !this.state.screensData.overrideShippingStatus,
                          });
                        }}
                        checked={this.state.screensData.overrideShippingStatus}
                      >
                        {' '}
                        Override Shipping Status
                      </Checkbox>
                    )}
                </div>
              )}

              {('priceCheckPrelisting' == _.get(self.state.screensData, 'productCustomData.currentProductAction') ||
                !_.get(this.state.screensData, 'selectedGBGProduct._id')) &&
                !_.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
                  return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                }) && (
                  <div className="top20">
                    <div className="text-bold font-size-17 bot5 top20 text-left">Internal Comment</div>
                    <FormControl
                      rows="5"
                      componentClass="textarea"
                      style={{
                        borderRadius: 5,
                        borderWidth: 1,
                        height: 70,
                        backgroundColor: '#FCF8CB',
                        borderColor: '#c9c9c9',
                      }}
                      value={this.state.screensData.InternalComment}
                      onChange={(e) => {
                        this.setScreensData({ InternalComment: e.target.value });
                      }}
                      placeholder=" "
                    />
                  </div>
                )}
            </Col>
          </Row>
          <div className="top30    text-center">
            <Button
              data-testid="next-screen-button"
              disabled={this.state.pending}
              className="btn btn-lg btn-primary  set-width"
              onClick={() => {
                if (this.state.pending) {
                  return;
                }
                this.setState({ pending: true });

                var dataToSave = {};
                if (this.state.screensData.overrideShippingStatus) {
                  dataToSave.OverrideShippable = true;
                }
                if (
                  !_.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
                    return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                  })
                ) {
                  if (_.size(_.get(this.state.screensData, 'FeesToAdd', []))) {
                    dataToSave['FeesToAdd'] = _.map(this.state.screensData.FeesToAdd, (fee) => {
                      var feeData = { feeType: fee.feeType };
                      if (!_.isUndefined(fee.amount)) {
                        feeData.amount = fee.amount;
                      }
                      return feeData;
                    });
                  }
                } else {
                  dataToSave.FeesToAdd = [];
                }
                if (this.state.screensData.InternalComment) {
                  dataToSave.Comments = [
                    {
                      CommentText: _.get(this.state.screensData, 'InternalComment', 'Image'),
                      CommentImageURL: _.get(this.state.images, [0, 's3FileURL'], undefined),
                      SentByUserID: base64ToHex(_.get(this.props.userReducer, ['user', '_id'])),
                      SentByUserName:
                        _.get(this.props.userReducer, ['user', 'firstName']) +
                        (_.get(this.props.userReducer, ['user', 'lastName'])
                          ? ' ' + _.get(this.props.userReducer, ['user', 'lastName'])
                          : ''),
                    },
                  ];
                }

                if (_.get(this.state.screensData, ['productAction'], '') == 'AddPrelisting') {
                  dataToSave.Shippable = this.state.screensData.Shippable;
                  if (
                    !_.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
                      return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                    })
                  ) {
                    if (this.state.screensData.Shippable == 'not_specified') {
                      self.props.displayMessage({
                        messageType: 'warning',
                        messageCode: 'Please, specify if product is shippable',
                      });
                      this.setState({ pending: false });
                      return false;
                    }
                  } else {
                    dataToSave.Shippable = false;
                    dataToSave.FeesToAdd = [];
                  }
                }

                let nextScreen = getNextScreenName.call(self, {
                  currentScreen: SCREENS.fees_screen.key,
                });

                self.setScreensData(dataToSave, () => {
                  self.goToNextScreen(nextScreen);
                });
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      );

    case SCREENS.service_listings_completion.key:
      return (
        <div className={'screen-box service_listings_completion'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col xs={6} className="align-center   text-center">
              <div className="screen_title">{' Is this the last product for this seller?'}</div>
            </Col>
          </Row>
          <Row className=" ">
            <Col xs={6} className="align-center   text-center">
              <div className="top30">
                <Button
                  className="btn btn-lg btn-primary  set-width --pink"
                  onClick={() => {
                    self.setScreensData({ serviceDataToUpdate: { Status: 'In Progress' } }, () => {
                      self.goToNextScreen(SCREENS.location_scanning_screen.key, {
                        nextScreenCallback: () => {
                          setTimeout(() => {
                            ReactDOM.findDOMNode(self.warehouseLocationInput).focus();
                          }, 100);
                        },
                      });
                    });
                  }}
                >
                  More products to go
                </Button>
              </div>

              <div className="top30">
                <Button
                  disabled={this.state.pending}
                  className="btn btn-lg btn-primary  set-width"
                  onClick={() => {
                    self.setScreensData({ serviceDataToUpdate: { Status: 'ServiceProductsDone' } }, () => {
                      // if (_.get(this.state.screensData, ['productAction'], '') == 'AddPrelisting' && !_.get(this.state.screensData, ['selectedGBGProduct', '_id'])) {
                      //     self.goToNextScreen(SCREENS.service_listings_completion.key)
                      // }else {
                      self.goToNextScreen(SCREENS.location_scanning_screen.key, {
                        nextScreenCallback: () => {
                          setTimeout(() => {
                            ReactDOM.findDOMNode(self.warehouseLocationInput).focus();
                          }, 100);
                        },
                      });
                      // }
                    });
                  }}
                >
                  Seller is DONE!
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );

    case SCREENS.confirmation_screen.key:
      var actionButtonText = '';
      var titleToDisplay = _.get(self.state.screensData, 'ProductNameToOverride', '')
        ? _.get(self.state.screensData, 'ProductNameToOverride', '')
        : _.get(self.state.screensData, 'ProductName', '');
      if (_.get(self.state.screensData, 'CurrentPartnerProductData._id')) {
        actionButtonText = 'Save';
      } else {
        if (_.get(self.state.screensData, ['productAction'], '') == 'EditListing') {
          actionButtonText = 'Update Listing';
        } else if (_.get(self.state.screensData, ['productAction'], '') == 'PostPrelisting') {
          actionButtonText = 'Finalize Listing';
        } else if (_.get(self.state.screensData, ['productAction'], '') == 'AddPrelisting') {
          if (
            _.includes(
              ['checkIntoTroubleshootingRoom', 'priceCheckPrelisting'],
              _.get(self.state.screensData, 'productCustomData.currentProductAction')
            )
          ) {
            actionButtonText = 'Create Pre-listing';
          } else {
            if (_.get(self.state.screensData, ['selectedGBGProduct', '_id'])) {
              actionButtonText = 'Post Listing';
            } else {
              actionButtonText = 'Create Pre-listing';
            }
          }
        } else if (self.state.currentFlow == '3PLProcessingFlow') {
          if (_.get(self.state.screensData, ['selectedGBGProduct', '_id'])) {
            actionButtonText = 'Post Listing';
          } else {
            actionButtonText = 'Create Pre-listing';
          }
        }
      }
      var modelVariationsValuesToAddInTitle = _.map(
        _.filter(_.get(this.state.screensData, 'selectedModelVariations', []), function (selectedModelVariation) {
          return selectedModelVariation.UseInTitle;
        }),
        function (modelVariation) {
          var modelVariationCopy = _.clone(modelVariation);
          if (_.get(modelVariationCopy, 'InputType') == 'text') {
            var itemFound = _.find(config.tagValueToTextMap, function (item) {
              return item.value == modelVariationCopy.value;
            });
            if (itemFound) {
              modelVariationCopy.value = itemFound.text;
            }
          }
          return modelVariationCopy;
        }
      );
      if (
        !_.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
          return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
        })
      ) {
        titleToDisplay +=
          (_.get(self.state.screensData, 'AdditionalTitleDetails', false)
            ? ' ' + _.get(self.state.screensData, 'AdditionalTitleDetails', '')
            : '') +
          (modelVariationsValuesToAddInTitle.length
            ? ', ' + _.map(modelVariationsValuesToAddInTitle, 'value').join(', ')
            : '');
      }
      var ShippableText = _.get(this.state.screensData, ['Shippable']) ? 'Yes' : 'No';
      var overrideCategory = _.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
        return (
          (_.includes(['Strollers'], item.Category) && !_.includes(['StrollerAccessories'], item.Subcategory)) ||
          _.includes(['carseat'], item.Category)
        );
      });
      if (
        this.state.screensData['Weight'] > 10 &&
        !_.get(this.state.screensData, ['OverrideShippable'], false) &&
        !overrideCategory
      ) {
        ShippableText = 'No';
        /* if weight more than 10lb, set Shippable to false */
        /* if item is a stroller, Shippable tag is set based only on selected Shippable option*/
      }
      const { GBGID } = this.state.screensData.CurrentProductData || {};
      return (
        <div className={'screen-box confirmation_screen'}>
          {displayPrevNextButtons.call(this, {})}
          {_.get(self.state.screensData, 'CurrentPartnerProductData._id') ? (
            <Row className="screen-content">
              <Col xs={6} className="align-center text-center">
                <div className="text-center label_text top20">
                  {_.get(self.state.screensData, ['CurrentPartnerProductData', 'ProductName'], '')}
                </div>
              </Col>
            </Row>
          ) : (
            <Row className="screen-content">
              <Col xs={6} className="align-center text-center">
                <div className="font-size-17 purple top20">
                  {_.get(self.state.screensData, ['selectedGBGProduct', '_id'], '') &&
                  !_.includes(
                    ['checkIntoTroubleshootingRoom', 'priceCheckPrelisting'],
                    _.get(self.state.screensData, 'productCustomData.currentProductAction')
                  ) ? (
                    <div>Please review and finalize the listing!</div>
                  ) : (
                    <div>
                      <div>
                        Last question before your pre-listing is ready and will be completed by a Virtual Wingmom
                      </div>
                    </div>
                  )}
                </div>

                {displayProductImages.call(self)}

                {_.get(self.state.screensData, ['selectedGBGProduct', '_id'], '') && (
                  <div className="flex-box top20">
                    <div className="text-bold">Title:</div>
                    <div data-testid="product-title-label" className=" label_text  bot0 text-left">
                      {titleToDisplay}
                    </div>
                  </div>
                )}
                {config.getEnvironmentName() !== 'production' &&
                  !_.get(self.state.screensData, 'qualityCheckRecordsMatched', true) && (
                    <div className="text-left top10">
                      <span className="text-bold font-size-17 bot5 top20  ">No quality checks matched</span>
                    </div>
                  )}
                <div className="flex-box top10">
                  <div className="  text-bold     ">Price:</div>
                  <div data-testid="price-label" className=" green  text-left">
                    {formatNumbers.formatMoney(_.get(this.state.screensData, 'ProductPriceToSave', 0))}
                  </div>
                </div>
                <div className="flex-box top10">
                  <div className="  text-bold     ">Condition:</div>
                  <div data-testid="condition-label" className="   text-left">
                    {' ' +
                      _.get(_.find(config.conditionsData, { number: this.state.screensData.Condition }), ['label'], '')}
                  </div>
                  {config.getEnvironmentName() !== 'production' && (
                    <div data-testid="condition-rating" className="left10 green  text-left">
                      {this.state.screensData.currentConditionRating}
                    </div>
                  )}
                </div>
                {_.get(this.state.screensData, ['LocationInWarehouse'], '') !== '' && (
                  <div className="flex-box top10">
                    <div className="  text-bold     ">Location:</div>
                    <div data-testid="warehouse-location-label" className="    text-left">
                      {_.get(this.state.screensData, 'LocationInWarehouse', '')}
                    </div>
                  </div>
                )}
                {(_.get(this.state.screensData, 'NewBrand') ||
                  _.get(this.state.screensData, ['selectedGBGProduct', '_id'])) &&
                  _.size(_.get(this.state.screensData, ['allGBGProductTagsToAssign'], [])) > 0 && (
                    <div
                      className="flex-box top10 cursor-pointer"
                      onClick={(event) => {
                        this.setScreensData({ modalTitle: 'GBG Product Tags', modalType: 'SelectGBGProductTags' });
                        this.setState({ showCustomContentModal: true });
                      }}
                    >
                      <div className="  text-bold     ">GBG Product Tags:</div>
                      <div data-testid="gbg-product-tags-label" className="   text-left">
                        {_.map(_.get(this.state.screensData, ['GBGProductTagsToAssign'], []), (tag, index) => {
                          return (
                            <div key={index}>
                              <span style={{ color: 'green' }} className="   ">
                                {' '}
                                {_.get(tag, 'label', 'n/a')}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  )}

                <div
                  className="flex-box top10 cursor-pointer"
                  onClick={(event) => {
                    this.setScreensData({ modalTitle: 'Age Groups', modalType: 'SelectAgeGroups' });
                    this.setState({ showCustomContentModal: true });
                  }}
                >
                  <div className="  text-bold     ">Age Groups:</div>
                  <div data-testid="age-groups-label" className="   text-left">
                    {_.size(_.get(this.state.screensData, ['ProductAgeRange'], [])) == 0 ? (
                      <span style={{ color: 'red' }}>Not Set</span>
                    ) : (
                      <div>
                        {_.map(_.get(this.state.screensData, ['ProductAgeRange'], []), (item, index) => {
                          return (
                            <div key={index}>
                              <span style={{ color: 'orange' }} className="   ">
                                {item.label}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>

                {_.size(_.get(this.state.screensData, ['ProductCategories'], [])) > 0 && (
                  <div className="flex-box top10">
                    <div className="  text-bold     ">Categories:</div>
                    <div data-testid="categories-label" className="   text-left">
                      {_.map(_.get(this.state.screensData, ['ProductCategories'], []), (item, index) => {
                        return (
                          <div key={index}>
                            <span className="right5 cyen">{_.startCase(item.Category)}</span>
                            {!_.isUndefined(item.Subcategory) && (
                              <span style={{ position: 'relative', top: -1, color: Colors.charcoal }}>&#8594;</span>
                            )}
                            {!_.isUndefined(item.Subcategory) && (
                              <span className="left5 cyen">{_.startCase(item.Subcategory)}</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <div className="clearfix"></div>
                  </div>
                )}
                {_.get(this.state.screensData, ['Details'], '') !== '' && (
                  <div className="flex-box top10">
                    <span className="   text-bold    ">{'Condition Details: '}</span>
                    <span data-testid="condition-details-label" className=" ">
                      {_.get(this.state.screensData, ['Details'], '')}
                    </span>
                  </div>
                )}

                <div className="flex-box top10">
                  <span className="   text-bold    ">{'Description: '}</span>
                  <span data-testid="description-label">{_.get(this.state.screensData, ['Description'], '')}</span>
                </div>
                <div className="flex-box top10">
                  <span className="   text-bold    ">{'Shippable: '}</span>
                  <span data-testid="shippable-label">{ShippableText}</span>
                </div>
                {(_.get(this.state.screensData, ['productAction'], '') == 'EditListing' ||
                  (this.state.screensData.Shippable &&
                    !_.get(this.state.screensData, ['selectedSearchAPIProduct', 'Weight'], false))) && (
                  <div
                    onClick={(event) => {
                      this.setScreensData({
                        modalTitle: 'Please enter approximate weight in lbs for this item',
                        modalType: 'SelectWeightModal',
                      });
                      this.setState({ showCustomContentModal: true });
                    }}
                    className="cursor-pointer flex-box top10"
                  >
                    <span className="   text-bold    ">{'Weight: '}</span>
                    <span data-testid="weight-label" className="purple">
                      {this.state.screensData.Weight == '' ? 'n/a' : this.state.screensData.Weight}
                    </span>
                  </div>
                )}
                {displayCalculatedBoxSize.call(this)}
                {displayProductBoxSize.call(this)}
              </Col>
            </Row>
          )}
          <div className="top30    text-center">
            <Button
              data-testid="next-screen-button"
              disabled={this.state.pending}
              className="btn btn-lg btn-primary set-width "
              onClick={() => {
                if (this.state.pending) {
                  return;
                }

                this.setState({ pending: true });

                var dataToSave = {};
                self.setScreensData(dataToSave, () => {
                  let resetScreensParams = {};
                  self
                    .processPartnerProduct()
                    .then(() => {
                      resetScreensParams = {
                        resetScreensCallback: () => {
                          BrowserPrint.getLocalDevices(
                            (deviceListData) => {
                              console.log('deviceListData 1', deviceListData);
                              self.setScreensData({
                                printerChecked: true,
                                selectedPrinter: _.get(deviceListData, ['printer', 0]),
                              });
                            },
                            (errorMessage) => {
                              console.log('errorMessage', errorMessage);
                              self.setScreensData({ printerChecked: true });
                              self.props.displayMessage({
                                messageType: 'warning',
                                messageCode:
                                  'Can not get data for a printer. ' +
                                  errorMessage +
                                  ' Please, check if printer is connected',
                              });
                            }
                          );
                        },
                        fieldsToKeep: [
                          'currentServiceRecord',
                          'CurrentProductData',
                          'ServiceItemMarket',
                          'CurrentPartnerProductData',
                          'nextProductNumber',
                        ],
                        nextScreen: SCREENS.barcode_printing_screen.key,
                      };
                      self.resetScreensData(resetScreensParams);
                    })
                    .catch((err) => {
                      console.log('error', err);
                      self.setState({ pending: false });
                    })
                    .finally(() => {});
                });
              }}
            >
              {actionButtonText}
            </Button>
          </div>
        </div>
      );
    case SCREENS.gbg_product_selection_screen.key:
      const { RMAProductsData = {} } = this.state.screensData;
      const rmaFlow =
        isPartner(this.state.screensData.GBGProductsBrand) && RMAProductsData.sendRMAProductProcessedEvents;
      const brandsModel = rmaFlow
        ? this.state.allBrandsWithModels.filter((record) =>
            brandsFromPartner(this.state.screensData.GBGProductsBrand).includes(record.value)
          )
        : this.state.allBrandsWithModels;

      return (
        <div className={'screen-box gbg_product_selection_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <div className="screen-content">
            <div className="font-size-20 purple text-center">{'Search GBG Product'}</div>
            <Row className="filter-inputs-box bot10 top10">
              <Col md={4} sm={4} xs={12} className=" top10">
                <ControlLabel>Search by Product Name</ControlLabel>
                <FormControl
                  data-testid="product-name-input"
                  value={_.get(this.state.screensData, 'GBGProductsearchText', '')}
                  ref={(input) => {
                    self.searchByProductNameInput = input;
                  }}
                  onChange={(e) => {
                    var value = e.target.value;
                    var self = this;
                    if (value !== '') {
                      var valueToCheck = _.trim(value);
                      if (valueToCheck.length > 3) {
                        self.setScreensData({
                          listingsSearchText: '',
                          searchUPCText: '',
                          GBGProductsearchText: value,
                          listingsFetched: false,
                        });
                      } else {
                        self.setScreensData({
                          listingsSearchText: '',
                          GBGProductsFetched: false,
                          listingsFetched: false,
                          searchUPCText: '',
                          GBGProductsearchText: value,
                        });
                      }
                    } else {
                      self.setScreensData(
                        {
                          listingsSearchText: '',
                          GBGProductsFetched: false,
                          searchUPCText: '',
                          GBGProductsearchText: value,
                        },
                        () => {
                          searchGBGProductsDebounce.call(self, {});
                        }
                      );
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      self.setScreensData(
                        {
                          searchUPCText: '',
                        },
                        () => {
                          searchGBGProducts.call(self, {});
                        }
                      );
                    }
                  }}
                  placeholder=""
                />
              </Col>

              <Col md={4} sm={4} xs={12} className="  top10">
                <ControlLabel>Brand (optional)</ControlLabel>
                <Select
                  tabIndex="0"
                  data-testid="brand-select-box"
                  placeholder="Brand"
                  clearable={!rmaFlow}
                  options={brandsModel}
                  onChange={(option) => {
                    var self = this;
                    self.setScreensData(
                      {
                        listingsSearchText: '',
                        listingsFetched: false,
                        GBGProductsBrand: option ? option.value : null,
                        GBGProductsModel: '',
                        searchUPCText: '',
                      },
                      () => {
                        prepareModelsOptions.call(self);
                        searchGBGProductsDebounce.call(self, {});
                      }
                    );
                  }}
                  value={_.get(this.state.screensData, 'GBGProductsBrand')}
                />
              </Col>

              <Col md={4} sm={4} xs={12} className="  top10">
                <ControlLabel>Model (optional)</ControlLabel>
                <Select
                  tabIndex="0"
                  disabled={!this.state.screensData.GBGProductsBrand}
                  data-testid="model-select-box"
                  placeholder="Model"
                  clearable={true}
                  options={this.modelsList}
                  onChange={(option) => {
                    var self = this;
                    self.setScreensData(
                      { listingsSearchText: '', searchUPCText: '', GBGProductsModel: option ? option.value : null },
                      () => {
                        searchGBGProductsDebounce.call(self, {});
                      }
                    );
                  }}
                  value={_.get(this.state.screensData, 'GBGProductsModel')}
                />
              </Col>
            </Row>

            <Row className="filter-inputs-box ">
              <Col md={4} sm={4} xs={12} className="  top10 bot10">
                <FormControl
                  type="text"
                  value={_.get(this.state.screensData, 'searchUPCText', '')}
                  data-testid="upc-code-input"
                  onChange={(e) => {
                    const value = e.target.value;
                    const self = this;
                    let lastValidUPCCode = this.state.screensData.lastValidUPCCode;
                    let screensDataToSet = {
                      listingsSearchText: '',
                      GBGProductsFetched: false,
                      listingsFetched: false,
                      GBGProductsModel: null,
                      GBGProductsBrand: null,
                      GBGProductsearchText: '',
                      searchUPCText: value,
                      lastValidUPCCode: lastValidUPCCode,
                    };

                    if (
                      isPartner(this.state.screensData.GBGProductsBrand) &&
                      this.state.screensData.sendRMAProductProcessedEvents
                    ) {
                      delete screensDataToSet.GBGProductsBrand;
                    }

                    self.setScreensData(screensDataToSet);
                  }}
                  ref={(input) => {
                    self.searchUPCInput = input;
                  }}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      if (this.state.screensData.searchUPCText.length > 3) {
                        if (validateBarcode(this.state.screensData.searchUPCText)) {
                          self.setScreensData({
                            lastValidUPCCode: this.state.screensData.searchUPCText,
                          });
                        }
                        searchUPCCodesDebounce.call(self);
                      } else {
                        this.props.displayMessage({
                          messageType: 'warning',
                          messageCode: 'Please specify at least 4 symbols for UPC code',
                        });
                      }
                    }
                  }}
                  placeholder="Search by UPC"
                />

                {this.state.screensData.GBGProductsFetched &&
                  this.state.screensData.searchUPCText &&
                  this.state.screensData.GBGProductsTotal == 0 && (
                    <div className="top10 red text-center font-size-18">
                      {'UPC Not Found. Please search by Product Name'}
                    </div>
                  )}
              </Col>
              <Col md={4} sm={4} xs={12} className="  top12 bot10">
                {(this.state.screensData.lastValidUPCCode || this.state.screensData.upcCodeToSave) && (
                  <div className="font-size-20">
                    <span>UPC code to link:</span>{' '}
                    <span className="text-bold green">
                      {this.state.screensData.lastValidUPCCode || this.state.screensData.upcCodeToSave}{' '}
                    </span>
                  </div>
                )}
              </Col>
            </Row>

            {this.state.currentFlow == '3PLProcessingFlow' &&
              this.state.screensData.selectedGBGProduct &&
              !self.FeatureFlags.DeterministicCondition && (
                <Row className="filter-inputs-box ">
                  <Col md={4} sm={4} xs={12} className="  top10 bot10">
                    <FormControl
                      type="text"
                      value={_.get(this.state.screensData, 'listingsSearchText', '')}
                      onChange={(event) => {
                        self.setScreensData(
                          {
                            GBGProductsFetched: false,
                            GBGProductsData: [],
                            listingsSearchText: event.target.value,
                          },
                          () => {
                            self.searchProductsDebounce({});
                          }
                        );
                      }}
                      placeholder="Search by SKU"
                    />
                  </Col>
                </Row>
              )}
            <Row>
              {config.getEnvironmentName() == 'local' && _.get(this.state.screensData.selectedGBGProduct, '_id') && (
                <Col md={5} xs={8}>
                  <div
                    className="top10 ptop7 pbot7  cursor-pointer  "
                    onClick={() => {
                      if (this.state.currentFlow == '3PLProcessingFlow') {
                        if (self.FeatureFlags.DeterministicCondition) {
                          return self.goToNextScreen(SCREENS.gbg_product_details_screen.key);
                        }

                        self.searchProducts();
                      } else {
                        self.goToNextScreen(SCREENS.gbg_product_details_screen.key);
                      }
                    }}
                    style={{
                      borderRadius: 5,
                      clear: 'both',
                      backgroundColor: '#c4d7ff',
                    }}
                  >
                    <div className="pull-left right15 ptop5 pbot5 pleft10 ">
                      <img
                        style={{
                          width: 100,
                          height: '100%',
                        }}
                        src={
                          _.get(
                            _.find(_.get(this.state.screensData.selectedGBGProduct, 'GBGProductImages', []), (item) => {
                              return _.size(_.get(item, 'ConditionsToMatch', [])) == 0;
                            }),
                            'URL',
                            ''
                          )
                            ? formatImageForBucket(
                                _.get(
                                  _.find(
                                    _.get(this.state.screensData.selectedGBGProduct, 'GBGProductImages', []),
                                    (item) => {
                                      return _.size(_.get(item, 'ConditionsToMatch', [])) == 0;
                                    }
                                  ),
                                  'URL',
                                  ''
                                )
                              )
                            : (config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : '') +
                              '/theme/assets/no-image-available.png'
                        }
                      />
                    </div>

                    <div className="ptop10">
                      {_.get(this.state.screensData.selectedGBGProduct, 'Brand') +
                        ' ' +
                        _.get(this.state.screensData.selectedGBGProduct, 'Model')}
                    </div>

                    <FaClose
                      style={{ position: 'relative', top: -39, right: -19, color: '#ff723a' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        self.setScreensData(
                          {
                            selectedGBGProduct: false,
                            modelVariations: {},

                            GBGProductsModel: '',
                          },
                          () => {
                            searchGBGProductsDebounce.call(self, {});
                          }
                        );
                      }}
                      className="cursor-pointer pull-right"
                    ></FaClose>
                    <div className="clearfix"></div>
                  </div>
                </Col>
              )}
            </Row>

            {this.state.currentFlow == '3PLProcessingFlow' && !self.FeatureFlags.DeterministicCondition && (
              <div>
                {_.get(this.state.screensData.selectedGBGProduct, '_id') &&
                  this.renderVariationsForSelectedGBGProduct()}
              </div>
            )}

            <Row>
              {(this.state.currentFlow == 'PostingFlow' ||
                (this.state.currentFlow == '3PLProcessingFlow' && !this.state.screensData.listingsFetched)) && (
                <Col md={9} xs={9} className={classNames('pleft10 top10 align-center')}>
                  {this.state.screensData.GBGProductsFetched && (
                    <div>
                      <div>
                        {this.state.screensData.GBGProductsTotal == 0 ||
                        this.state.screensData.GBGProductsTotal >
                          (config.getEnvironmentName() == 'local' ? 800 : 100) ? (
                          <div>
                            {this.state.screensData.GBGProductsTotal == 0 && (
                              <div className="messageBox font-size-19">{'No matching GBG Products found'}</div>
                            )}
                            {this.state.screensData.GBGProductsTotal >
                              (config.getEnvironmentName() == 'local' ? 800 : 100) && (
                              <div className="messageBox font-size-19">
                                Please, refine your search. Too many GBG Products found.
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="">
                            <PaginationBox
                              ref={'pagination'}
                              currentPage={_.get(this.state.screensData, 'GBGProductsPage', 0)}
                              perPage={20}
                              total={_.get(this.state.screensData, 'GBGProductsTotal', 1)}
                              search={(params) => {
                                if (self.state.screensData.searchUPCText) {
                                  searchUPCCodesDebounce.call(self, params);
                                } else {
                                  searchGBGProductsDebounce.call(self, params);
                                }
                              }}
                            ></PaginationBox>
                            {displayGBGProductsInGrid.call(this, _.get(this.state.screensData, 'GBGProductsData', []), {
                              screensData: this.state.screensData,
                              imageClickHandler: (item) => {
                                self.setState({ showCustomContentModal: true });
                                self.setScreensData({
                                  modalTitle: item.textLabel,
                                  modalType: 'DisplayImageModal',
                                  imageToDisplay: item.imageURL,
                                });
                              },
                              itemClickHandler: (item) => {
                                this.calculateRecommendedPriceData = false;

                                var dataToSave = {
                                  GBGProductNotFound: false,
                                  selectedGBGProduct: item,
                                  ProductCategories: prepareProductCategories.call(self, {
                                    selectedGBGProduct: item,
                                    AllCategories: self.state.AllCategories,
                                  }),
                                  modelVariations: {},
                                  ProductName:
                                    (_.get(item, ['Brand']) == 'Unknown' ? '' : _.get(item, ['Brand']) + ' ') +
                                    _.get(item, ['Model']),
                                  GBGProductImage:
                                    item.GBGProductImage && item.GBGProductImage.URL ? item.GBGProductImage.URL : '',
                                  PersonalNote: _.get(item, 'GBGNote', ''),
                                  GBGProductsBrand: item.Brand,
                                  GBGProductsModel: item.Model,
                                };

                                const { UPCCodeRecord = {} } = item;
                                if (self.state.screensData.lastValidUPCCode) {
                                  dataToSave.upcCodeToSave = self.state.screensData.lastValidUPCCode;
                                }
                                const { VariationLinks = [] } = UPCCodeRecord;

                                if (!dataToSave.upcCodeToSave && VariationLinks.length) {
                                  let modelVariations = getModelVariationsForUPCCode(item, UPCCodeRecord);
                                  for (const modelVariation of Object.values(modelVariations)) {
                                    dataToSave.modelVariations[modelVariation.label] = modelVariation.value;
                                  }
                                }

                                let donationGBGProduct = false;
                                let fieldsToKeep = [];
                                if (
                                  _.find(_.get(dataToSave, ['ProductCategories'], []), (item) => {
                                    return (
                                      _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory)
                                    );
                                  })
                                ) {
                                  fieldsToKeep = fieldsToKeep.concat(['Description', 'Condition']);
                                  _.extend(dataToSave, {
                                    images: [],
                                    ProductAgeRange: prepareProductAgeRange.call(self, {
                                      selectedGBGProduct: item,
                                      selectedCategories: _.get(self.state.screensData['selectedCategories'], []),
                                      AllCategories: self.state.AllCategories,
                                      Condition: 5 /* use Gently Used for Donations */,
                                    }),
                                  });

                                  if (item.Model.toLowerCase().includes('to sell')) {
                                    donationGBGProduct = true;
                                    let screenDataToUpdate = {
                                      CurrentPartnerProductData: {},
                                      OriginalPrice: 0,
                                      Shippable: false,
                                      Condition: 5,
                                    };
                                    const { TrackingNumbers = [] } = self.state.screensData;

                                    if (self.state.currentFlow == '3PLProcessingFlow' && TrackingNumbers.length) {
                                      dataToSave.TrackingNumbers = [
                                        {
                                          ...self.state.screensData.TrackingNumbers[0],
                                          Disposition: 'salvage',
                                        },
                                      ];
                                    }

                                    Object.assign(dataToSave, screenDataToUpdate);
                                  }
                                }

                                var GBGProductChanged = false;

                                const { selectedGBGProduct = false } = this.state.screensData;
                                if (
                                  selectedGBGProduct == false ||
                                  (_.get(self.state.screensData, 'selectedGBGProduct._id') &&
                                    item._id !== _.get(self.state.screensData, 'selectedGBGProduct._id'))
                                ) {
                                  GBGProductChanged = true;
                                }

                                var nextScreen = SCREENS.gbg_product_details_screen.key;

                                self.setScreensData(dataToSave, () => {
                                  if (this.state.currentFlow == '3PLProcessingFlow') {
                                    if (self.FeatureFlags.DeterministicCondition) {
                                      let UPCCode =
                                        this.state.screensData.lastValidUPCCode || this.state.screensData.upcCodeToSave;

                                      /* when returning to this screen lastValidUPCCode is not available */
                                      if (
                                        UPCCode == this.state.screensData.selectedGBGProduct.UPCCode ||
                                        _.isEmpty(this.state.screensData.selectedGBGProduct.UPCCode)
                                      ) {
                                        self.setScreensData(
                                          {
                                            QuantityToAdd: 1,
                                            ProductCategories: prepareProductCategories.call(this, {
                                              selectedGBGProduct: _.get(
                                                self.state.screensData,
                                                'selectedGBGProduct',
                                                {}
                                              ),
                                              AllCategories: self.state.AllCategories,
                                            }),
                                            GBGProductsData: [],
                                            imageToDisplay: false,
                                          },
                                          () => {
                                            self.updateScreensData({
                                              upToCurrentScreen: true,
                                              additionalFieldsToKeep: GBGProductsFieldsToKeep,
                                              callbackMethod: function () {
                                                if (donationGBGProduct) {
                                                  return self.getNextSKU().then((nextProductNumber) => {
                                                    self.goToNextScreen(SCREENS.gbg_product_details_screen.key, {
                                                      screenDataToSet: { nextProductNumber: nextProductNumber },
                                                    });
                                                  });
                                                }

                                                self.goToNextScreen(SCREENS.gbg_product_details_screen.key, {
                                                  screenDataToSet: { similarProductsFetched: true },
                                                });
                                              },
                                            });
                                          }
                                        );
                                      } else {
                                        self.props.displayMessage({
                                          messageType: 'warning',
                                          messageCode:
                                            'UPC number is wrong.\n To add +1, please, search for the complete UPC code and select the item.',
                                        });
                                      }

                                      return;
                                    } else {
                                      self.searchProducts();
                                    }
                                  } else {
                                    console.log('GBGProductChanged', GBGProductChanged);
                                    if (GBGProductChanged) {
                                      let screensDataToSave = {};
                                      getSimilarProducts
                                        .call(self, {
                                          selectedGBGProduct: _.get(self.state.screensData, ['selectedGBGProduct'], {}),
                                        })
                                        .then((getSimilarProductsResponse) => {
                                          screensDataToSave.allSimilarProducts =
                                            getSimilarProductsResponse.allSimilarProducts;
                                          screensDataToSave.similarProductsFetched = true;
                                          screensDataToSave.similarProducts = processSimilarProducts.call(self, {
                                            Condition: self.state.screensData.Condition,
                                            allSimilarProducts: screensDataToSave.allSimilarProducts,
                                          });
                                          self.setScreensData(screensDataToSave);
                                        });

                                      self.updateScreensData({
                                        upToCurrentScreen: true,
                                        additionalFieldsToKeep: _.concat(fieldsToKeep, GBGProductsFieldsToKeep),
                                        callbackMethod: function () {
                                          self.goToNextScreen(nextScreen);
                                        },
                                      });
                                    } else {
                                      self.goToNextScreen(nextScreen);
                                    }
                                  }
                                });
                              },
                            })}
                          </div>
                        )}
                      </div>

                      <div className="top30  set-width align-center">
                        <Button
                          data-testid="gbg-product-not-found-button"
                          className="red-button  btn btn-primary btn-lg  set-width "
                          type="button"
                          disabled={this.state.pending}
                          onClick={() => {
                            return self.setScreensData(
                              {
                                allSimilarProducts: [],
                                GBGProductNotFound: true,
                                images:
                                  [] /* reset images as variation or external images could be added for previously selected GBG Product. Also when trying to save variation image for a pre-listing, it throw error  */,
                                selectedGBGProduct: false,
                                selectedSearchAPIProduct: {},
                                similarProducts: [],
                                SearchTerm: '',
                                SearchTermBrand: '',
                                SearchTermModel: '',
                                modelVariations: {},
                                upcCodeToSave: self.state.screensData.lastValidUPCCode
                                  ? self.state.screensData.lastValidUPCCode
                                  : '',
                              },
                              () => {
                                this.calculateRecommendedPriceData = {};
                                if (this.state.currentFlow == '3PLProcessingFlow') {
                                  self.updateScreensData({
                                    upToCurrentScreen: true,
                                    additionalFieldsToKeep: GBGProductsFieldsToKeep,
                                    callbackMethod: function () {
                                      self.generateNewSKU.call(self);
                                    },
                                  });
                                } else {
                                  /* Posting flow*/
                                  self.setState({ pending: true });
                                  self.updateScreensData({
                                    upToCurrentScreen: true,
                                    additionalFieldsToKeep: GBGProductsFieldsToKeep,
                                    callbackMethod: function () {
                                      if (self.FeatureFlags.DeterministicCondition) {
                                        return self.goToNextScreen(SCREENS.categories_screen.key);
                                      }
                                      self.goToNextScreen(SCREENS.conditions_screen.key);
                                    },
                                  });
                                }
                              }
                            );
                          }}
                        >
                          GBG Product Not Found
                        </Button>
                      </div>
                    </div>
                  )}
                </Col>
              )}

              {!self.FeatureFlags.DeterministicCondition &&
                this.state.currentFlow == '3PLProcessingFlow' &&
                !this.state.screensData.GBGProductsFetched && (
                  <Col md={6} xs={6} className={classNames('top10 align-center')}>
                    {this.state.screensData.listingsFetched && (
                      <div>
                        <div>
                          {this.state.screensData.listingsData.length == 0 ? (
                            <div className="messageBox font-size-19  ">
                              {'No matching listings found' +
                                (_.get(this.state.screensData.selectedGBGProduct, '_id')
                                  ? ' for ' +
                                    _.get(this.state.screensData.selectedGBGProduct, 'Brand') +
                                    ' ' +
                                    _.get(this.state.screensData.selectedGBGProduct, 'Model')
                                  : '')}
                            </div>
                          ) : (
                            <div className="">
                              <div className="text-bold text-center bot7">
                                {'Select listing ' +
                                  (_.get(this.state.screensData.selectedGBGProduct, '_id')
                                    ? ' for ' +
                                      _.get(this.state.screensData.selectedGBGProduct, 'Brand') +
                                      ' ' +
                                      _.get(this.state.screensData.selectedGBGProduct, 'Model')
                                    : '')}{' '}
                              </div>

                              <BootstrapTable
                                data={_.get(this.state.screensData, 'listingsData', [])}
                                ref="table"
                                hover={true}
                                style={{ maxHeight: 500 }}
                                bordered={false}
                              >
                                <TableHeaderColumn
                                  dataField="_id"
                                  isKey={true}
                                  hidden={true}
                                  autoValue={true}
                                  hiddenOnInsert
                                >
                                  Id
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                  width="60px"
                                  editable={false}
                                  columnClassName="product-listings-column"
                                  dataFormat={customFormatter}
                                  formatExtraData={{
                                    path: ['getObject'],
                                    format: (item) => {
                                      let SKU = item.SKU || '';
                                      const match = sharedUtil.matchSKU(SKU, { maxDigitsNumber: 3 });
                                      let locationInWarehouse = '';
                                      if (match) {
                                        SKU = match[1];
                                        if (match[2]) {
                                          locationInWarehouse = match[2].replace('-', '');
                                        }
                                      }
                                      return (
                                        <Row
                                          onClick={() => {
                                            let UPCCode =
                                              this.state.screensData.lastValidUPCCode ||
                                              this.state.screensData.upcCodeToSave;

                                            /* when returning to this screen lastValidUPCCode is not available */
                                            if (
                                              UPCCode == this.state.screensData.selectedGBGProduct.UPCCode ||
                                              _.isEmpty(this.state.screensData.selectedGBGProduct.UPCCode)
                                            ) {
                                              self.updateScreensData({
                                                upToCurrentScreen: true,
                                                additionalFieldsToKeep: GBGProductsFieldsToKeep,
                                                callbackMethod: function () {
                                                  self.goToQualityCheckScreen(
                                                    {
                                                      QuantityToAdd: 1,
                                                      ProductCategories: prepareProductCategories.call(this, {
                                                        selectedGBGProduct: _.get(
                                                          self.state.screensData,
                                                          'selectedGBGProduct',
                                                          {}
                                                        ),
                                                        AllCategories: self.state.AllCategories,
                                                      }),
                                                      CurrentPartnerProductData: item,
                                                      GBGProductsData: [],
                                                      imageToDisplay: false,
                                                    },
                                                    { qualityChecksNotFoundScreen: SCREENS.fees_screen.key }
                                                  );
                                                },
                                              });
                                            } else {
                                              self.props.displayMessage({
                                                messageType: 'warning',
                                                messageCode:
                                                  'UPC number is wrong.\n To add +1, please, search for the complete UPC code and select the item.',
                                              });
                                            }
                                          }}
                                          className="  pleft10 ptop15 pbot10 pright10"
                                          style={{}}
                                        >
                                          <Col xs={12} className="text-left">
                                            <div className="pull-left right15   ">
                                              <img
                                                style={{
                                                  width: 150,
                                                  height: '100%',
                                                }}
                                                src={
                                                  _.get(item, 'OriginalImages.0.URL')
                                                    ? formatImageForBucket(_.get(item, 'OriginalImages.0.URL'))
                                                    : (config.getEnvironmentName() == 'local'
                                                        ? 'http://localhost:3037'
                                                        : '') + '/theme/assets/no-image-available.png'
                                                }
                                              />
                                            </div>
                                            <div className="font-size-19">{_.get(item, 'ProductName')} </div>

                                            <div className="font-size-21 text-bold top20">
                                              <span className="purple">{SKU}</span>
                                              {locationInWarehouse !== '' ? (
                                                <span>
                                                  <span> - </span> <span className="orange">{locationInWarehouse}</span>
                                                </span>
                                              ) : (
                                                ''
                                              )}
                                            </div>
                                          </Col>
                                        </Row>
                                      );
                                    },
                                  }}
                                  dataAlign="center"
                                >
                                  Products
                                </TableHeaderColumn>
                              </BootstrapTable>
                              <PaginationBox
                                ref={'pagination'}
                                customTotalBoxClass={'float-none'}
                                currentPage={_.get(this.state.screensData, 'listingsPage', 0)}
                                perPage={50}
                                total={_.get(this.state.screensData, 'listingsTotal', 1)}
                                search={(params) => {
                                  self.searchProducts(
                                    _.extend(params, {
                                      //  forceSearchProducts:true
                                    })
                                  );
                                }}
                              ></PaginationBox>
                            </div>
                          )}
                        </div>
                        {(_.get(this.state.screensData, 'selectedGBGProduct._id') ||
                          _.get(this.state.screensData, 'GBGProductNotFound')) && (
                          <div className="top30  set-width align-center">
                            <Button
                              disabled={this.state.pending}
                              className="btn btn-lg btn-primary custom-btn set-width "
                              onClick={() => {
                                self.updateScreensData({
                                  upToCurrentScreen: true,
                                  additionalFieldsToKeep: GBGProductsFieldsToKeep,
                                  callbackMethod: function () {
                                    self.generateNewSKU.call(self);
                                  },
                                });
                              }}
                            >
                              <div>
                                <div>Not Found</div>
                                <div>(Generate New SKU)</div>
                              </div>
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </Col>
                )}
            </Row>
          </div>
        </div>
      );
    case SCREENS.listing_selection_screen.key:
      return (
        <div className={'screen-box listing_selection_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <ListingSelectionScreen
            {...this.props}
            renderVariationsForSelectedGBGProduct={() => this.renderVariationsForSelectedGBGProduct()}
            searchProductsDebounce={self.searchProductsDebounce}
            generateNewSKUHandler={() =>
              self.goToNextScreen(SCREENS.fees_screen.key, {
                nextScreenCallback: () => {
                  self.generateNewSKU.call(self);
                },
              })
            }
            selectProductListing={(selectedProduct) =>
              selectProductListing.call(self, { selectedProduct, GBGProductsFieldsToKeep })
            }
            setScreensData={(dataToUpdate, callback) =>
              this.setScreensData(dataToUpdate, () => {
                callback && callback();
              })
            }
            {..._.pick(this.state, ['screensData', 'pending', 'currentFlow'])}
          ></ListingSelectionScreen>
        </div>
      );

    case SCREENS.rma_products_selection_screen.key:
      return (
        <div className={'screen-box rma_products_selection_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <RMAProductsSelectionScreen
            {...this.props}
            generateNewSKUHandler={() =>
              self.goToNextScreen(SCREENS.fees_screen.key, {
                nextScreenCallback: () => {
                  self.generateNewSKU.call(self);
                },
              })
            }
            selectRMAProduct={(item) => {
              const { RMAItemsForGBGProduct = [] } = item;
              let RMAProductsToUse = [];
              let nextScreen = SCREENS.conditions_screen.key;
              let matchingGBGProduct = false;

              if (!item.rmaProductNotFound) {
                if (RMAItemsForGBGProduct.length) {
                  RMAProductsToUse = RMAItemsForGBGProduct.filter((item) => item.RMAProductStatus == 'rma_created');
                  const { GBGProductRecord = {} } = RMAItemsForGBGProduct[0];

                  if (GBGProductRecord._id) {
                    matchingGBGProduct = GBGProductRecord;
                  }
                } else {
                  RMAProductsToUse = [_.omit(item, ['GBGProductRecord'])];
                }
              }

              this.calculateRecommendedPriceData = false;
              const { GBGProductImage = {}, Brand = '', Model = '', GBGNote = '' } = matchingGBGProduct;
              let dataToSave = {
                GBGProductNotFound: false,
                selectedGBGProduct: matchingGBGProduct,
                ProductCategories: prepareProductCategories.call(self, {
                  selectedGBGProduct: matchingGBGProduct,
                  AllCategories: self.state.AllCategories,
                }),
                GBGProductsData: [],
                imageToDisplay: false,
                modelVariations: {},
                ProductName: matchingGBGProduct ? `${Brand} ${Model}` : '',
                GBGProductImage: GBGProductImage.URL ? GBGProductImage.URL : '',
                PersonalNote: GBGNote,
                GBGProductsBrand: item.RMAProductBrand,
                GBGProductsModel: Model,
                RMAProductsData: {
                  ...this.state.screensData.RMAProductsData,
                  rmaProductNotFound: item.rmaProductNotFound,
                  RMAProductsToUse,
                },
              };

              self.setScreensData(dataToSave, () => {
                let screensDataToSave = {};
                getSimilarProducts
                  .call(self, { selectedGBGProduct: self.state.screensData.selectedGBGProduct })
                  .then((getSimilarProductsResponse) => {
                    screensDataToSave.allSimilarProducts = getSimilarProductsResponse.allSimilarProducts;
                    screensDataToSave.similarProductsFetched = true;
                    screensDataToSave.similarProducts = processSimilarProducts.call(self, {
                      Condition: self.state.screensData.Condition,
                      allSimilarProducts: screensDataToSave.allSimilarProducts,
                    });
                    self.setScreensData(screensDataToSave);
                  });
                self.updateScreensData({
                  upToCurrentScreen: true,
                  additionalFieldsToKeep: GBGProductsFieldsToKeep,
                  callbackMethod: function () {
                    self.goToNextScreen(nextScreen, {
                      nextScreenCallback: () => {
                        prepareModelsOptions.call(self);
                        searchGBGProductsDebounce.call(self, {});
                      },
                    });
                  },
                });
              });
            }}
            setScreensData={(dataToUpdate, callback) =>
              this.setScreensData(dataToUpdate, () => {
                callback && callback();
              })
            }
            {..._.pick(this.state, ['screensData'])}
          ></RMAProductsSelectionScreen>
        </div>
      );
    case SCREENS.gbg_product_details_screen.key:
      const { GBGProductImage = '' } = this.state.screensData;
      return (
        <div className={'screen-box gbg_product_details_screen'}>
          {displayPrevNextButtons.call(this, {})}
          <Row className="screen-content">
            <Col md={9} xs={9} className="align-center text-center">
              <div className="font-size-17 top20 align-center  set-width text-bold   ">
                {this.state.screensData.overrideProductName
                  ? this.state.screensData.ProductName
                  : (_.get(self.state.screensData, ['selectedGBGProduct', 'Brand']) == 'Unknown'
                      ? ''
                      : _.get(self.state.screensData, ['selectedGBGProduct', 'Brand']) + ' ') +
                    _.get(self.state.screensData, ['selectedGBGProduct', 'Model']) +
                    ' ' +
                    _.get(this.state.screensData, 'AdditionalTitleDetails', '')}
              </div>
              <div className="font-size-17 top20 align-center  set-width text-bold   ">
                {this.state.screensData.AddDetailsToTitleVisible ? (
                  <FaMinusCircle
                    style={{ color: Colors.purpleLighter2, position: 'relative', top: -2 }}
                    className=" right10 cursor-pointer  "
                    onClick={() => {
                      self.setScreensData({
                        AddDetailsToTitleVisible: !this.state.screensData.AddDetailsToTitleVisible,
                      });
                    }}
                  />
                ) : (
                  <FaPlusCircle
                    style={{ color: Colors.purpleLighter2, position: 'relative', top: -2 }}
                    className="right10  cursor-pointer  "
                    onClick={() => {
                      self.setScreensData({
                        AddDetailsToTitleVisible: !this.state.screensData.AddDetailsToTitleVisible,
                      });
                    }}
                  />
                )}
                {'Add title details'}
              </div>

              {this.state.screensData.AddDetailsToTitleVisible && (
                <div style={{ position: 'relative' }} className="top10 align-center set-width">
                  <FormControl
                    value={_.get(this.state.screensData, 'AdditionalTitleDetails', '')}
                    placeholder="Add details to title"
                    onChange={(e) => {
                      this.setScreensData({
                        AdditionalTitleDetails: e.target.value,
                      });
                    }}
                    type="text"
                  />
                </div>
              )}
              <div>
                <div className="image-and-description-box bot30">
                  {_.get(this.state.screensData, ['productAction'], '') !== 'EditListing' && GBGProductImage !== '' && (
                    <div style={{ width: 150 }} className="  right15   ">
                      <img
                        style={{
                          width: 100,
                          height: 100,
                        }}
                        src={GBGProductImage}
                      />
                    </div>
                  )}
                  <div style={{ width: 350 }}>
                    <div className="font-size-16  top20 text-left">{'Product Description'}</div>
                    <div style={{ position: 'relative' }} className="top10">
                      {_.get(this.state.screensData, 'selectedGBGProduct.GBGNote') !==
                        this.state.screensData.PersonalNote && (
                        <IORefresh
                          style={{ position: 'absolute', top: 0, right: -26, color: Colors.blueButton }}
                          onClick={() => {
                            self.setScreensData({
                              PersonalNote: _.get(this.state.screensData, 'selectedGBGProduct.GBGNote'),
                            });
                          }}
                          className="cursor-pointer pull-right"
                        ></IORefresh>
                      )}
                      <FormControl
                        data-testid="product-description-text-input"
                        value={_.get(this.state.screensData, 'PersonalNote', '')}
                        componentClass="textarea"
                        spellCheck="true"
                        rows="8"
                        placeholder="Tell customers about this item and what makes this product shine"
                        onChange={(e) => {
                          this.setScreensData({
                            PersonalNote: sentenceCase(e.target.value),
                          });
                        }}
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {renderModelVariationOptions.call(this, {})}
              <div className="top30">
                <Button
                  data-testid="next-screen-button"
                  disabled={this.state.pending}
                  className="btn btn-lg btn-primary set-width "
                  onClick={() => {
                    var self = this;
                    if (this.state.pending) {
                      return;
                    }

                    var dataToSave = {
                      AdditionalTitleDetails: _.get(this.state.screensData, 'AdditionalTitleDetails', ''),
                      selectedModelVariations: [],
                      Description: this.state.screensData.PersonalNote,
                      useSearchAPI: '',
                      images: [],
                    };
                    if (!dataToSave.Description) {
                      return this.props.displayMessage({
                        messageType: 'warning',
                        messageCode: 'Please specify Description for the product',
                      });
                    }

                    this.setState({ pending: true });

                    if (
                      _.get(
                        this.state.screensData,
                        'selectedGBGProduct.Brand',
                        _.get(this.state.screensData, 'NewBrand', '')
                      ).toLowerCase() !== 'bundle'
                    ) {
                      dataToSave.selectedModelVariations = prepareModelVariationsToSave.call(self);
                      const { modelVariations = {} } = this.state.screensData;
                      let modelVariationsFiltered =
                        {}; /* remove variations selected when searching listings on listing_selection_screen */

                      for (const [key, value] of Object.entries(modelVariations)) {
                        if (key.includes('###')) {
                          modelVariationsFiltered[key] = value;
                        }
                      }

                      dataToSave.modelVariations = modelVariationsFiltered;
                    }

                    var GBGProductImageUrl = _.get(
                      _.find(_.get(this.state.screensData, 'selectedGBGProduct.GBGProductImages', []), (item) => {
                        return _.size(_.get(item, 'ConditionsToMatch', [])) == 0;
                        /* by default display GBGProductImage without ConditionsToMatch*/
                      }),
                      'URL',
                      ''
                    );
                    if (self.state.screensData.GBGProductImage) {
                      console.log('from state');
                      GBGProductImageUrl = self.state.screensData.GBGProductImage;
                    }
                    console.log('GBGProductImageUrl', GBGProductImageUrl);
                    if (GBGProductImageUrl) {
                      var GBGProductImageObject = _.find(
                        _.get(this.state.screensData, 'selectedGBGProduct.GBGProductImages', []),
                        (image) => {
                          return image.URL == GBGProductImageUrl;
                        }
                      );
                      if (
                        _.size(_.get(GBGProductImageObject, 'ConditionsToMatch', [])) > 0 ||
                        _.get(GBGProductImageObject, 'Type') == 'External'
                      ) {
                        /* include only External image or an image linked to variations*/
                        dataToSave['images'].push({
                          fullUri: GBGProductImageUrl,
                          mime: mime.lookup(GBGProductImageUrl),
                          uploadProgress: 1,
                          imageID: generateMongoObjectID(),
                          type: _.get(GBGProductImageObject, 'Type', 'User'),
                          CustomImageData: { Source: 'GBGProductImage' },
                        });
                      }
                    }

                    self.doNotLookUpForAmazonProducts = false;

                    dataToSave.ProductAgeRange = prepareProductAgeRange.call(self, {
                      selectedGBGProduct: _.get(this.state.screensData, ['selectedGBGProduct'], {}),
                      selectedCategories: _.get(this.state.screensData['selectedCategories'], []),
                      AllCategories: this.state.AllCategories,
                    });
                    console.log('dataToSave 2', dataToSave);
                    dataToSave.selectedSearchAPIProduct = {};

                    if (
                      _.get(self.state.screensData, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle' ||
                      _.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
                        return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
                      })
                    ) {
                      self.doNotLookUpForAmazonProducts = true;
                    }
                    console.log(' this.doNotLookUpForAmazonProducts', self.doNotLookUpForAmazonProducts);
                    console.log(
                      'ASIN',
                      _.get(self.state.screensData, ['selectedGBGProduct', 'OriginalProductData', 'ASIN'], false)
                    );
                    var promise = Promise.resolve(true);
                    if (
                      _.get(self.state.screensData, ['selectedGBGProduct', 'OriginalProductData', 'ASIN'], false) &&
                      !self.doNotLookUpForAmazonProducts
                    ) {
                      /* search Amazon Product by ASIN to compare its price with the stored one*/
                      promise = getAmazonProductData.call(
                        self,
                        _.get(self.state.screensData, ['selectedGBGProduct', 'OriginalProductData', 'ASIN']),
                        dataToSave
                      );
                    }
                    return promise.then((data) => {
                      console.log('after get amazon data', dataToSave);

                      var nextScreen = SCREENS.quality_checks_screen.key;
                      console.log(
                        'AmazonProductFoundByASIN',
                        _.get(dataToSave.selectedSearchAPIProduct, 'AmazonProductFoundByASIN', false)
                      );

                      if (
                        self.state.currentFlow == 'PostingFlow' &&
                        _.get(this.state.screensData, ['productAction'], '') == 'AddPrelisting'
                      ) {
                        nextScreen = SCREENS.conditions_screen.key;

                        if (self.FeatureFlags.DeterministicCondition) {
                          nextScreen = SCREENS.quality_checks_screen.key;
                        }
                      }

                      if (
                        this.doNotLookUpForAmazonProducts ||
                        _.get(dataToSave.selectedSearchAPIProduct, 'AmazonProductFoundByASIN', false)
                      ) {
                      } else if (
                        _.get(this.state.screensData, [
                          'selectedGBGProduct',
                          'OriginalProductData',
                          'RetailProductPrice',
                        ]) /* use RetailProductPrice in case Amazon product not found by ASIN or it is found, by price is not longer available for it */
                        //  &&  !_.get(dataToSave, ['selectedGBGProduct', 'OriginalProductData', 'ASIN'], false)
                      ) {
                        console.log(
                          'user retail price',
                          _.get(this.state.screensData, [
                            'selectedGBGProduct',
                            'OriginalProductData',
                            'RetailProductPrice',
                          ])
                        );
                        dataToSave.OriginalPrice = _.get(
                          this.state.screensData,
                          ['selectedGBGProduct', 'OriginalProductData', 'RetailProductPrice'],
                          ''
                        ).toString();
                        /* if Price is available, do not need to select Amazon product*/
                      } else {
                        nextScreen = SCREENS.product_options_screen.key;
                      }

                      if (
                        this.state.currentFlow == '3PLProcessingFlow' &&
                        !_.get(self.state.screensData, 'selectedGBGProduct._id')
                      ) {
                        nextScreen = SCREENS.categories_screen.key;
                      }

                      const { ProductCategories = [], similarProductsFetched } = this.state.screensData;

                      const donationCategory = ProductCategories.find((item) => {
                        return item.Category == 'Donate' || item.Subcategory == 'Donate';
                      });

                      if (donationCategory) {
                        nextScreen = SCREENS.confirmation_screen.key;
                      }

                      if (nextScreen == SCREENS.product_options_screen.key) {
                        if (!similarProductsFetched && this.props.appData.FeatureFlags.EnableMinimumPriceQC) {
                          this.setState({ pending: false });
                          return this.props.displayMessage({
                            messageType: 'warning',
                            messageCode: 'Please, wait till similar products are loaded',
                          });
                        }
                        searchProductsWithAPI.call(self, { useSearchAPI: '' }).then((searchDataResponse) => {
                          console.log('searchProductsWithAPI', searchDataResponse);
                          _.extend(dataToSave, searchDataResponse);
                          //    dataToSave.searchAPIProductsFetched = true
                          // dataToSave.searchAPIProducts  =searchDataResponse
                          self.setScreensData(dataToSave, () => {
                            self.goToNextScreen(nextScreen);
                          });
                        });
                      } else if (nextScreen == SCREENS.quality_checks_screen.key) {
                        if (!similarProductsFetched && this.props.appData.FeatureFlags.EnableMinimumPriceQC) {
                          this.setState({ pending: false });
                          return this.props.displayMessage({
                            messageType: 'warning',
                            messageCode: 'Please, wait till similar products are loaded',
                          });
                        }
                        self.goToQualityCheckScreen(dataToSave, {
                          qualityChecksNotFoundScreen: SCREENS.fees_screen.key,
                        });
                      } else {
                        self.setScreensData(dataToSave, () => {
                          self.goToNextScreen(nextScreen);
                        });
                      }
                    });
                  }}
                >
                  {'Continue'}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
  }
}
